export default {
  sidebar: {
    alarms: 'Alarms',
    configuration: 'Configuration',
    customers: 'Customers',
    dashboard: 'Dashboard',
    documents: 'Documents',
    document_types: 'Document Types',
    kpis: 'KPIS Dash',
    locations: 'Locations',
    logout: 'Logout',
    manage_organization: 'Manage Organization',
    organization: 'Organization',
    organization_settings: 'General Information',
    organization_brokers: 'Brokers',
    reservations: 'Reservations',
    pricing_rulesets: 'Pricing Rulesets',
    fleets: 'Fleets',
    settings: 'Settings',
    skus: 'SKUs',
    subscriptions: 'Subscriptions',
    tasks: 'Tasks',
    users: 'Employees',
    reservation_rulesets: 'Reservation Rulesets',
    users_groups: 'User Groups',
    dealers: 'Dealers',
    vehicle_types: 'Vehicle Types',
    vehicles: 'Vehicles',
    vehicles_groups: 'Service Groups',
    business_hours: 'Business Hours',
    tax_rulesets: 'Tax Rulesets',
    payments: 'Payments',
    transactions: 'Transactions',
    'legacy-reports': 'Legacy Reports',
    reporting: 'Reporting',
    promo_codes: 'Promo Codes',
    charts: 'Charts',
    credit_types: 'Credit Types',
    partners: 'Partners',
    notifications: 'Notifications',
    billing: 'Billing',
    account_statement: 'Account Statement',
    statement_entries: 'Statement Entries',
    invoices: 'Invoices',
    nfc: 'NFC Cards',
    sections: {
      location_management: 'Location Management',
      operations: 'Operations',
      organization: 'Organization',
      pricing: 'Pricing',
      tools: 'Tools',
      vehicle_management: 'Vehicle Management',
      billing: 'Billing',
      reports: 'Reports Management',
      settings: 'Settings',
    },
    authentication: 'Authentication',
  },
  status: {
    ACTIVE: 'Active',
    INSHOP: 'In Shop',
    RETIRED: 'Retired',
    INACTIVE: 'Inactive',
    INPROGRESS: 'In Progress',
    CONNECTED: 'Connected',
    ONBOARDING: 'Onboarding',
    RESERVED: 'Reserved',
    AVAILABLE: 'Available',
    COMPLETED: 'Completed',
    NOSHOW: 'No show',
    BLOCKED: 'Blocked',
    UNSHARING: 'Unsharing',
  },
  units: {
    min: 'minute',
    minute: 'minute',
    hr: 'hour',
    hour: 'hour',
    hours: 'hour',
    day: 'day',
    week: 'week',
    month: 'month',
  },
  units_abbrevation: {
    min: 'min',
    minute: 'min',
    hr: 'hr',
    hour: 'hr',
    hours: 'hr',
    day: 'day',
    d: 'day',
    week: 'wk',
    month: 'mon',
  },
  payment_statuses: {
    NONE: 'None',
    FAIL: 'Failed',
    PREAUTH: 'PreAuth',
    DISPUTED: 'Disputed',
    COMPLETE: 'Complete',
    REFUNDED: 'Refunded',
    INPROGRESS: 'Pending',
    PREAUTHREFUNDED: 'PreAuth Refunded',
    FAILED: 'Failed',
    SUCCEEDED: 'Succeeded',
  },
  brokers_slugs: {
    stripe_broker: 'Stripe',
    kinto_link: 'KINTO Link',
    plaid: 'Plaid',
    STPAC: 'Stripe',
    STPPM: 'Stripe',
    KLKAC: 'KINTO Link',
    KLKPM: 'KINTO Link',
    KLK: 'KINTO Link',
  },
  invoice_statuses: {
    PAID: 'Paid',
    DRAFT: 'Not submitted',
    QUOTE: 'Quote',
    UNPAID: 'Unpaid',
    PENDING: 'Pending',
    PARTIAL: 'Partial',
    OVERPAID: 'Overpaid',
    CANCELLED: 'Cancelled',
    UNPAIDINPROGRESS: 'Payment in progress',
    VOID: 'Void',
  },
  payment_methods: {
    ACH: 'ACH',
    OTHER: 'Other',
    DEBITCARD: 'Debit Card',
    CREDITCARD: 'Credit Card',
    PREPAIDCARD: 'Prepaid Card',
    bank_account: 'Bank Account',
    ACCOUNTCREDIT: 'Account Credit',
    RECONCILIATION: 'Reconciliation',
  },
  sources: {
    User: 'User',
    Subscription: 'Subscription',
  },
  source_types: {
    OwnerVehicleGroup: 'Fleet',
    Vehicle: 'Vehicle',
  },
  group_type: {
    DRIVER: 'Driver',
    TASKS: 'Tasks',
    CONTRACTOR: 'Contractor',
    EMPLOYEE: 'Employee',
    PARENT: 'Parent',
    BUSINESS: 'Business',
  },
  reservations_statuses: {
    ADMINCANCELLED: 'Cancelled (Admin)',
    USERCANCELLED: 'Cancelled (User)',
    INPROGRESS: 'In Progress',
    COMPLETED: 'Completed',
    RESERVED: 'Reserved',
    REJECTED: 'Rejected',
    PENDING: 'Pending',
    NOSHOW: 'No show',
  },
  alarms_statuses: {
    OPEN: 'Open',
    CLOSED: 'Closed',
  },
  qualifications_statuses: {
    COMPLETED: 'Completed',
    INPROGRESS: 'In Progress',
    NOTSTARTED: 'Not started',
  },
  tasks_statuses: {
    OPEN: 'Open',
    APPROVED: 'Approved',
    CANCELLED: 'Cancelled',
    COMPLETED: 'Completed',
    ALL_ACTIVE: 'All active',
    INPROGRESS: 'In progress',
    ALL_INACTIVE: 'All inactive',
    PENDING_APPROVAL: 'Pending Approval',
  },
  priorities: {
    ALL: 'All',
    LOW: 'Low',
    MEDIUM: 'Medium',
    HIGH: 'High',
    URGENT: 'Urgent',
  },
  brokers: {
    title: 'Brokers',
    connect: 'Connect',
    connected: 'Connected',
    disconnected: 'Disconnected',
    disconnect: 'Disconnect',
    name: 'Name',
    status: 'Status',
    active_brokers: 'Active Brokers',
    available_brokers: 'Available Brokers',
    empty: 'No records to display',
    information: 'Broker Information',
    broker_name: 'Broker Name',
    broker_id: 'Broker ID',
    created_time: 'Date Created',
    id: 'ID',
    vehicle_id: 'Enter External ID',
    connect_manually: 'Connect Manually',
    connect_automatically: 'Connect Automatically',
    added_successfully: 'Broker added successfully to vehicle',
  },
  refresh: 'Refresh',
  actions: {
    LOCK: 'Lock',
    UNLOCK: 'Unlock Doors and Disable Engine',
    UNLOCKANDENABLE: 'Unlock Doors and Enable Engine',
    REFRESHGPS: 'Refresh Position',
    REFRESHDATA: 'Request Latest Data',
    change_vehicle: 'Change Vehicle',
    edit_address: 'Edit Address',
    edit_delivery_pickup: 'Edit Vehicle Delivery / Pickup',
    cancel: 'Cancel',
    schedule_delivery: 'Schedule Delivery',
    mark_delivered: 'Mark as Delivered',
    schedule_return: 'Schedule Return',
    mark_returned: 'Mark as Returned',
    cancel_return_process: 'Cancel Return Process',
    end_subscription: 'End Subscription',
    refund: 'Refund',
    edit_periods: 'Edit Periods',
  },
  telemetry: {
    mi: 'Mi',
    km: 'Km',
    gps: 'GPS',
    fuel: 'Fuel',
    units: 'Units',
    value: 'Value',
    cancel: 'Cancel',
    status: 'Status',
    vitals: 'Vitals',
    gps_time: 'Time',
    title: 'Telemetry',
    time_label: 'Updated on',
    continue: 'Continue',
    odometer: 'Odometer',
    load_data: 'Load data',
    edit: 'Edit Telemetry',
    battery: 'Battery 12V',
    door_status: 'Door',
    power_status: 'Power',
    gps_location: 'GPS Location',
    charge_level: 'State of Charge',
    is_charging: 'Electric Charging',
    gps_coordinates: 'Coordinates',
    no_vitals: 'No data available',
    update_gps: 'Refresh',
    no_gps_location: 'No GPS Location data',
    distance_location: 'Distance to location',
    data_hidden: 'Location data not available due to Privacy Policies.',
    reservations_inprogress: 'Reservation In Progress.',
    agree_text:
      'I agree that I am accessing this location information in accordance with all applicable laws and internal policies.',
    odometer_method: {
      ABSOLUTE: 'Absolute',
      MANUAL: 'Manual',
      DISTANCE_SINCE_CLEARANCE: 'Dist. from DTC reset',
    },
    restricted_access: 'Restricted access',
  },
  auth: {
    start: 'Start',
    otp: 'OTP',
    login: 'Login',
    password: 'Password',
    welcome_to: 'Welcome to {{name}}',
    sign_in_access: 'Sign in to access',
    want_switch_account: 'Change network',
    confirm_email: 'Email verification',
    resend_code: 'Resend code',
    set_password: 'Set password',
    back_to_login: 'Back to login',
    missing_token: 'No token provided',
    forgot_password: 'Forgot Password',
    select_network: 'Select a network',
    change_password: 'Change password',
    reset_password: 'Reset my password',
    reset_my_password: 'Reset my password',
    enter_code: 'ENTER THE CODE TO CONTINUE',
    confirm_password: 'Confirm your password',
    otp_resend_text: "Haven't you received the code?",
    password_reset_email: 'Password reset email sent!',
    change_password_success: 'Password successfully updated.',
    driver_app_download_prompt:
      'If you’re a driver, please download the app in Google Play Store or App Store to get started.',
    admin_login_prompt: 'If you are an administrator, refresh to login.',
    otp_text: 'We have sent a verification code to your email',
    confirmEmail: 'Congratulations, your email has been verified!',
    confirmEmailText: 'Your email has been verified successfully, now you can use your account.',
    change_password_successfully: 'Password changed successfully!',
    change_password_set_text: 'Use the form below to set your password',
    change_password_change_text: 'Use the form below to change your password',
    forgot_password_text: 'Enter your email and instructions will be sent to you!',
    auth_limit_error_text_1: 'You have reached the limit of attempts, please',
    auth_limit_error_text_2: 'try again',
    auth_limit_error_text_3: 'in a few minutes to unlock the field.',
  },
  roles: {
    driver: 'Driver',
    none: 'No access',
    base: 'Base user',
    operator: 'Operator',
    admin: 'Administrator',
    driver_crew: 'Driver crew',
    fleet_manager: 'Fleet Manager',
    group_manager: 'Group Manager',
    driver_loaner: 'Driver Loaner',
    driver_manager: 'Driver Manager',
    superadmin: 'Super Administrator',
    service_manager: 'Service Manager',
    operations_lead: 'Operations Lead',
    driver_business: 'Driver Business',
  },
  registrationStatus: {
    NEEDSAPPROVAL: 'Needs approval',
    DISQUALIFIED: 'Disqualified',
    DUPLICATE: 'Duplicate',
    FRAUD: 'Fraud',
    AWAITINGCUSTOMER: 'Awaiting customer action',
  },
  qualsActions: {
    SCHEDULEDELIVERY: 'Schedule delivery',
    MARKASDELIVERED: 'Mark as Delivered',
    MARKASRETURNED: 'Mark as Returned',
    SCHEDULERETURN: 'Schedule Return',
    NEEDSAPPROVAL: 'Needs approval',
    DELIVERY: 'Delivery',
    RETURN: 'Return',
    DELETIONREQUESTED: 'Deletion requested',
  },
  reasons: {
    DRIVERISSUE: 'Customer Issue',
    CLEANING: 'Cleaning & Veh Supplies',
    INSPECTION: 'Registration & Inspection',
    INSTALLATION: 'Hardware Installation',
    ACCIDENT: 'Accident',
    PLANNEDMAINETANCE: 'Planned Maintenance',
    UNPLANNEDREPAIR: 'Unplanned Repair',
    PREPARATION: 'Initial Preparation',
    RETIRED: 'Permanently Retired',
    TEMPORARY: 'Temporary',
    OTHER: 'Other',
    OFFLINE: 'Offline',
    BUFFER: 'Vehicle in Buffer',
    CANCEL: 'Cancel',
    VEHICLECHANGE: 'Vehicle change',
    NOSHOW: 'No show',
  },
  userStatus: {
    ACTIVE: 'Active',
    PENDING: 'Pending',
    BLOCKED: 'Blocked',
    SUSPENDED: 'Suspended',
    DELETED: 'Inactive',
  },
  invoicesTypes: {
    billing: 'Payments Out',
    invoice: 'Payments In',
  },
  statementTypes: {
    billing: 'Money Out',
    invoice: 'Money In',
  },
  vehicleStatus: {
    AVAILABLE: 'Available',
    ACTIVE: 'Active',
    INSHOP: 'In Shop',
    RETIRED: 'Retired',
    RESERVED: 'Reserved',
    BLOCKED: 'Blocked',
    SUSPENDED: 'Suspended',
    RESERVED_LATE: 'Reserved',
    INACTIVE: 'Inactive',
  },
  status_details: {
    RETURN: 'Return',
    DELIVERY: 'Delivery',
    NEEDSAPPROVAL: 'Needs Approval',
  },
  subscription_status: {
    unsubscribed: 'Unsubscribed',
    subscribed: 'Subscribed',
  },
  customers: {
    reject_customer_deletion: 'Reject Customer Deletion',
    accept_customer_deletion: 'Accept Customer Deletion',
    undefined: 'No user defined',
    title: 'Customers',
    customer: 'Customer',
    logs: 'Customers Logs',
    birthdate: 'Date of Birth',
    add_credits: 'Add credits',
    create_customer: 'Create customer',
    update_customer: 'Update customer',
    driver_license: 'Driver License ID',
    license_state: 'Driver License State',
    confirm_delete_title: 'Confirm Delete User',
    license_country: 'Driver License Country',
    customer_information: 'Customer Information',
    license_expiration_date: 'License Expiration Date',
    invalid_zip: 'Postal Code not valid for',
    invalid_zip_nz: 'Postal code must be four digits.',
    select_country_first: 'Please select a country first',
    no_credits: 'No records to display',
    basic_info: 'Basic Information',
    contact_info: 'Contact Info',
    license_info: 'Driver License Info',
    jurisdiction: 'Jurisdiction',
    full_name: 'Full Name',
    role: 'Role',
    invite_code: 'Invite Code',
    email: 'Email',
    phone: 'Phone',
    city: 'City',
    state: 'State/Province',
    address: 'Address',
    zip: 'Postal Code',
    delete: 'Delete customer',
    title_delete: 'Confirmation message',
    confirm_delete:
      'Are you sure you want to permanently delete this user? This action cannot be undone. We suggest reviewing the conditions for account deletion.',
    delete_success: 'Customer deleted successfully',
    business_information: 'Business Information',
    federal_id: 'Federal ID',
    us_dot: 'US dot',
    doing_business_as: 'Doing business as',
    dba: 'Doing business as',
    us_dot_id: 'US dot',
    organization_state: 'Lessee’s State of Incorporation/Organization',
    organization_type: 'Lessee’s Type of Business Organization',
    basic_information: 'Basic Information',
    contact_information: 'Contact Information',
    driver_license_information: 'Driver License Information',
    additional_information: {
      title: 'Additional Information',
      tooltip:
        'This is an open-text field designed for organizations that need extra or personalized details from their drivers.',
    },
    internal_id: 'User Alternate ID',
    email_subscription_status: 'E-mail Subscription Status',
    sms_subscription_status: 'SMS Subscription Status',
    driver_license_id: 'Driver License ID',
    driver_license_state: 'Driver License State',
    organization: {
      organization_state: 'Lessee’s State of Incorporation/Organization',
      organization_type: 'Lessee’s Type of Business Organization',
    },
    account_brokers: 'Account Brokers',
    user_brokers: 'User Brokers',
    deletion_REJECTED: 'Customer deletion has been rejected',
    deletion_ACCEPTED: 'Customer deletion has been accepted',
  },
  deletionStatus: {
    REQUESTED: 'Deletion Requested',
    REJECTED: 'Deletion Rejected',
    ACCEPTED: 'Deletion Accepted',
    DELETED: ' Deleted',
  },
  documents: {
    title: 'Documents',
    document: 'Document',
    create_document: 'Create document',
    add_document_type: 'Add new document type',
    versions_placeholder: 'No records to display',
    documents_placeholder: 'No records to display',
    approved: 'Approved',
    cancel: 'cancel',
    create: 'create',
    create_new_document: 'Create new document',
    creation_date: 'Creation date',
    edit_document: 'Edit document',
    create_new_version: 'Create new version',
    create_new_version_cta:
      'You don’t have created versions yet, click on the button below to create a version',
    declined: 'Declined',
    default_version: 'Default Version',
    delete_document: 'Delete document',
    delete_document_msg: 'Are you sure you want to delete this document?\nYou can’t undo this.',
    delete_file: 'Delete',
    delete_file_msg: 'Are you sure you want to delete this file?\nYou can’t undo this.',
    delete_version: 'Delete version',
    delete_version_msg: 'Are you sure you want to delete this version?\nYou can’t undo this.',
    document_name: 'Document name',
    document_list: 'Document list',
    documents: 'Documents',
    download_file: 'Download',
    documents_details: 'Document',
    drop_file_instructions1: 'Drop file to upload or ',
    drop_file_instructions2: 'browse',
    edit_version: 'Edit version',
    expiration_date: 'Expiration date',
    expired: 'Expired',
    file: 'File',
    no_file_attached: 'No file attached',
    pending: 'Pending',
    rename: 'rename',
    replace_file: 'Replace',
    set_as_default_version: 'Set as default version',
    show_only_expired: 'Show only expired',
    success_download: 'Your download will start soon!',
    success_generate_docs: 'Cards are generating. Please check your email shortly',
    success_status: 'Document status changed to',
    success_upload: 'Document uploaded successfully!',
    success_update_version: 'Version updated successfully!',
    success_deleted_version: 'Version deleted successfully!',
    tags: 'Tags',
    update: 'update',
    upload_file: 'Upload file',
    uploaded: 'Uploaded',
    version_attachment: 'Version Attachment',
    version_name: 'Version name',
    version_details: 'Version Details',
    versions: 'Versions',
    view_file: 'View',
    search: 'Search version',
    date_range: 'Date range',
    none: '',
    document_type: 'Document type',
    search_document_type: 'Search document type',
    create_document_type: 'Create document type',
    update_document_type: 'Update document type',
    empty_versions:
      'There is not created versions yet, click on the button above to create a version.',
  },
  payments: {
    title: 'Payments',
    account: 'Account',
    description: 'Description',
    add_credit: 'Add credit',
    tax_exempt: 'Tax Exempt',
    tax_paid: 'Tax Paid',
    tax_invoiced: 'Tax Invoiced',
    edit_account: 'Edit Account',
    total_credit: 'Total Credit',
    total_invoiced: 'Total Invoiced',
    amount_issued: 'Amount Issued',
    issue_amount: 'Issue Amount ($)',
    total_past_due: 'Total Past Due',
    spending_limit: 'Spending Limit',
    credit_history: 'Credits History',
    credit_applied: 'Credit Applied!',
    amount_consumed: 'Amount Aonsumed',
    paid_with_credits: 'Paid With Credits',
    paid_with_card: 'Paid With Card',
    credits_available: 'Credits Available',
    credit_revoked: 'Credit revoked successfully!',
    account_updated: 'Account updated successfully!',
    invoice_id: 'Invoice ID',
    type: 'Type',
    payee: 'Payee',
    method: 'Method',
    paid: 'Paid',
    search_invoice: 'Search by Invoice ID',
    customer: 'Customer',
    id: 'Payment ID#%{id}',
    logs: 'Payments Logs',
    information: 'Payment Information',
    details: 'Payment Details',
    related_to: 'Related To',
    preauth: 'Preauth',
    refunded: 'Refunded',
    add_payment_method: 'Add Payment Method',
    add_card: 'Add Card',
    add_payment_card: 'Add Payment Card',
    card_number: 'Card Number',
    name: 'Card Holder Name',
    expiry: 'Expiry (MM/YYYY)',
    cvc: 'CVC',
    zip_code: 'Postal Code',
    payment_method: 'Payment Method',
    brand: 'Brand',
    card: 'Last four digits of the card',
    account_last_four_digits: 'Last four digits of the account',
    expiration: 'Expiration',
    holder_type: 'Account Holder Type',
    holder_name: 'Account Holder Name',
    router_number: 'Routing Number',
    account_number: 'Account Number',
    ach_info: 'Bank account Info',
    credit_card_info: 'Credit card Info',
    types: {
      CREDIT_CARD: 'Credit Card',
      ACH: 'ACH',
    },
    stripe_error: 'Could not validate, please review your card information',
    verify_title: 'One more step to complete',
    verify_description:
      'During the next 1-2 days you’ll receive two deposits in your connected account. Please come back here, click the “Verify Account” link, and enter the amounts of the two deposits to start using this payment method.',
    verify_modal_title: 'Verify Account',
    verify_modal_description:
      'Please check your bank account for two deposits and enter them below. It may take a few days for the deposits to show in your account.',
    verify_code_label: 'Deposit #{{number}} (¢)',
  },
  transactions: {
    title: 'Transactions',
    display_name: 'Name',
    amount: 'Amount',
    customer: 'Customer',
    emitter: 'Emitter',
    captured: 'Captured',
    transaction_id: 'Transaction ID',
    bastion_id: 'Bastion ID',
    account_statement_due_time: 'Account Statement Due Date',
    account_statement_id: 'Account Statement ID',
    search_payment: 'Search by Transaction ID',
    search_account_statement: 'Search by Account Statement ID',
    search_bastion: 'Search by Bastion ID',
    filter_by_account_statement: 'Filter by Account Statement',
  },
  qualifications: {
    title: 'Qualifications',
    bypass: 'Bypass',
    reject: 'Reject',
    approve: 'Approve',
    decline: 'Decline',
    clear: 'Clear',
    invoice: 'Invoice ID',
    manula_approve_msg_2: 'this requirement?',
    document_status: 'Document status changed to',
    manula_approve_msg_1: 'Are you sure you want to',
    document_upload: 'Document uploaded successfully!',
    qualification_not_found: 'No records to display',
    bypass_msg_1: 'You are about to bypass the requirement',
    bypass_msg_2: 'If, by doing this, the requirements group',
    bypass_msg_3: 'is complete, this action cannot be undone. Are you sure you want to proceed?',
    passed_status: 'Passed',
    failed_status: 'Failed',
    not_performed_status: 'Not Performed',
    not_applicable_satus: 'Not applicable',
    declined_status: 'Declined',
    approved_status: 'Approved',
    AUTOAPPROVED: 'Auto approved',
    NEEDSAPPROVAL: 'Needs Approval',
    MANUALAPPROVED: 'Manual Approved',
    MANUALREJECTED: 'Manual Rejected',
    clear_msg_1: 'Are you sure you want to clear this requirement?',
  },
  modals: {
    document: 'Document',
    upload_document: 'Upload Document',
    select_document: 'Select document',
    conflicting_reservations: {
      title: 'Conflicting Reservations',
      description_1: 'This vehicle are assigned to one or more bookings.',
      description_2:
        'Changing their status will impact their reservations. To proceed, please review the list and click the "Reassign Reservations" or “Cancel Reservations” buttons.',
      cancel_reservations: 'CANCEL RESERVATIONS',
      reassign_reservations: 'REASSIGN RESERVATIONS',
      confirm_cancel_description: 'Are you sure you want to cancel all conflicting reservations?',
      confirm_reassign_desc_1:
        "By confirming, we will attempt to reassign all reservations but it's possible some (or all) can't be moved.",
      confirm_reassign_desc_2: "Any reservations that we can't reassign will be cancelled.",
      success_title: 'Your request is being processed',
      success_message:
        "We are processing your request. We'll email you the results once complete. This may take a few minutes.",
      failed_title: 'We were unable to process your request.',
      failed_message:
        'We had a problem processing your request. Please close this message and try again.',
      cancel: 'CANCEL',
      confirm: 'CONFIRM',
      confirm_action: 'Confirm Action',
      reassign_tooltip: "All reassignments will be limited to the same 'Service Group'",
    },
  },
  users: {
    update_customer_info: 'Update Customer Info',
    service_groups_from_users: 'Service Groups from User Groups',
    fleets_from_user_groups: 'Fleets from User Groups',
    role: 'Role',
    reason: 'Reason',
    logs: 'User logs',
    invite: 'Invite User',
    confirmed: 'Confirmed',
    user_group: 'User Group',
    delete: 'Delete employee',
    create: 'Create employee',
    update: 'Update employee',
    update_info: 'Update',
    change_role: 'Change role',
    send_invite: 'Send Invite',
    assign_nfc: 'Assign NFC Card',
    change_status: 'Change status',
    add_vehicle_group: 'Add %{type}',
    create_new: 'Create new employee',
    select_status: 'Select new status',
    create_customer: 'Create customer',
    assign_nfc_card: 'Assign NFC Card',
    change_user_role: 'Change user role',
    user_information: 'User Information',
    rrd_device: 'RRD Device (8 characters)',
    reset_pwd_link: 'Send password reset link',
    confirmation_link: 'Send confirmation link',
    confirm_sms: 'Send mobile phone confirm SMS',
    change_employee_status: 'Change Employee Status',
    download_documents: 'Download insurance documents',
    generate_documents: 'Generate Insurance Documents',
    no_vehicle_groups: 'There are no service groups assigned',
    customer_invited_msg: 'User has been invited Successfully',
    reason_description: 'Why are you suspending/blocking this user?',
    no_vehicle_groups_assigned: 'No service groups has been assigned',
    no_fleet_groups_assigned: 'No fleets has been assigned',
    status_updated_successfully: 'User status updated succesfully',
    role_updated_successfully: 'User role updated succesfully',
    user_updated_successfully: 'User updated successfully',
    customer_created_successfully: 'Customer created successfully',
    password_reset_sussess_message: 'Password reset email sent successfully',
    email_confirmation_success_message: 'Confirmation email sent successfully',
    nfc_success_message: 'The NFC Token has been assigned to user successfully',
    phone_confirmation_success_message: 'Phone Confirmation SMS sent successfully',
    vg_success_message: 'Service group has been removed from user successfully',
    confirm_delete: "Are you sure you want to delete this employee? You can't undo this.",
    delete_success: 'User deleted successfully',
    change_status_msg:
      'You are going to change the status of the %{user_type}. Are you sure you want to continue?',
    update_user_type: 'Update %{user_type}',
    types: {
      EMPLOYEE: 'employee',
      CUSTOMER: 'customer',
    },
    internal_id_tooltip:
      'This is an open-text field designed for organizations that need extra or personalized details from their employees.',
    show_only_deletion_requested: 'Only Deletion Requested',
  },
  configuration: {
    core: 'Core',
    title: 'Configuration',
    integrations: 'Integrations',
    updated_success: 'Configuration saved successfully!',
  },
  organization_brokers: {
    title: 'Manage Settings',
    tab_title: 'Setup Broker',
    broker_provider: "Let's Get Started",
    broker_provider_description:
      'On this screen, you can easily establish your connection with your preferred brokers. Keep in mind that each broker requires it\'s own unique information, so just use the "Connect" and "Disconnect" buttons and follow the steps to get set up.',
  },
  common: {
    continue: 'Continue',
    back: 'Back',
    done: 'done',
    previous: 'Previous',
    unconfirmed: 'Unconfirmed',
    detail_title: '%{description} ID#%{id}',
    up_to: 'Up To',
    from: 'From',
    amount: 'Amount',
    created: 'Created',
    valid_tax_type: 'Please select a valid tax type',
    show_archived: 'Show archived',
    select_user_type: "Select user's type",
    select_user_group: 'Select user group',
    select_user: 'Select user',
    search_user: 'Search a user',
    driver: 'Driver',
    drivers: 'Drivers',
    employees: 'Employees',
    assign: 'Assign',
    alias: 'Alias',
    serial: 'Serial',
    user_search: 'User search',
    entries: 'Entries',
    total_amount: 'Total Amount',
    approve: 'approve',
    reject: 'reject',
    reference: 'Reference',
    by_month: 'by Month',
    by_year: 'by Year',
    by_status: 'by Status',
    partnership: 'Partnership',
    total: 'Total',
    month: 'Month',
    year: 'Year',
    log: 'Log',
    app_order: 'App Order',
    clear: 'clear',
    show_only: 'Show Only',
    date_label: {
      range: 'Date Range',
      only: 'Dates selected',
    },
    from_start_time: 'From %{startTime}',
    till_end_time: 'Till %{endTime}',
    discard_title: 'Discard invoice',
    discard_msg: 'Are you sure about deleting this invoice?',
    save_title: 'Save invoice',
    save_msg:
      'This invoice will be saved internally, if you want to send it to your Partner or Customer please use the option Submit.',
    submit_title: 'Submit invoice',
    submit_msg:
      'When Submitted, this invoice will be seen by your Partner or Customer. Do you still want to Submit it?',
    discard: 'Discard',
    save_and_next: 'Save & Next',
    lmkb_tooltip: 'LM Knowledge Base',
    type_of: 'Type of',
    organization: 'Organization',
    organization_type: 'Organization Type',
    by_type: 'By Type',
    logo: 'Logo',
    ok: 'OK',
    input_check: `Input has an unsupported character`,
    or: 'or',
    to: 'to',
    To: 'To',
    groups: 'Groups',
    id: 'ID',
    add: 'Add',
    remove: 'Remove',
    no: 'No',
    yes: 'Yes',
    edit: 'Edit',
    city: 'City',
    name: 'Name',
    next: 'Next',
    when: 'When',
    send: 'Send',
    fleet: 'Fleet',
    clone: 'Clone',
    other: 'Other',
    number: 'Number',
    open: 'Open',
    active: 'Active',
    period: 'Period',
    system: 'System',
    parent: 'Parent',
    refresh: 'Refresh',
    details: 'Details',
    confirm: 'Confirm',
    partner: 'Partner',
    partners: 'Partners',
    address: 'Address',
    country: 'Country',
    actions: 'Actions',
    pricing: 'Pricing',
    invoice: 'Invoice',
    services: 'Services',
    category: 'Category',
    related_to: 'Related to',
    fleet_owner: 'Fleet Owner',
    location: 'Location',
    locations: 'Locations',
    activation: 'Activation',
    in_shop: 'In shop',
    service: 'Service',
    customer: 'Customer',
    employee: 'Employee',
    inactive: 'Inactive',
    reserved: 'Reserved',
    inprogress: 'In progress',
    payment_id: 'Payment ID',
    partner_name: 'Partner Name',
    error_message: 'Error message',
    save_as_draft: 'Save as draft',
    effective_from: 'Effective from',
    shared_services: 'Services Sharing',
    shared_partners: 'Partners Sharing',
    type_error: 'You should specify a number',
    type_error_integer: 'You should specify an integer',
    min_0: 'This field must be greater than or equal to 0',
    max_1: 'This field must be less than or equal to 1',
    max_100: 'This field must be less than or equal to 100',
    address_2: 'Address 2',
    change_status: 'Change status',
    expiration_date: 'Expiration date',
    zip: 'Postal Code',
    time_zone: 'Time Zone',
    state: 'State/Province',
    are_you_sure: 'Are you sure?',
    description: 'Description',
    delete: 'Delete',
    start_reserved: 'Start Reserved',
    end_reserved: 'End Reserved',
    due_date: 'Due date',
    empty_list: 'No records to display',
    end: 'End time',
    file: 'File',
    true: 'True',
    view: 'View',
    false: 'False',
    cancel: 'Cancel',
    INACTIVE: 'Inactive',
    start: 'Start time',
    filter_by_customer: 'Customer',
    filter_by: 'Filter by',
    filter_by_status: 'Filter by status',
    filter_by_partner: 'Filter by Partner',
    change: 'Change',
    due_time: 'Due time',
    invalid_email: 'Invalid email',
    invalid_value: 'Invalid value',
    only_digits: 'Must be only digits',
    max_value_4: 'Must be exactly 4 digits',
    max_value_8: 'This field is required and lower than 8',
    max_value: 'This field must be less than or equal to %{max_value}',
    custom_min_value: 'This field must be more than or equal to  %{min_value}',
    custom_min_length_value: 'This field must be at least %{min_value} characters long',
    min_value: 'This field is required and greater than 0',
    min_value_8: 'This field is required and greater than 8',
    optional: 'Optional',
    page_size: 'Page size',
    max_character: 'This field cannot be more than {{max}} characters long',
    password_match:
      'Password must be at least 8 characters, including one lowercase, one uppercase, one number and one special character.',
    past_due: 'Past due',
    priority: 'Priority',
    pwd_match: 'Both password need to be the same',
    id_slug_match: 'ID Slug must be alphanumeric without spaces',
    required_field: 'This field is required',
    save: 'Save',
    search: 'Search',
    status: 'Status',
    status_details: 'Status Details',
    submit: 'Submit',
    tags: 'Tags',
    title: 'Title',
    upload: 'Upload',
    user: 'User',
    vehicle: 'Vehicle',
    vehicles: 'Vehicles',
    verify: 'Verify',
    vehicle_group: 'Service Group',
    update: 'Update',
    view_all: 'View all',
    more_info: 'More Info',
    view_details: 'View Details',
    manage_organization: 'Manage Organization',
    user_group: 'User Group',
    user_group_details: 'User Group details',
    no_records_to_display: 'There are no records to display',
    organization_settings: 'General Information',
    organization_info: 'Organization Info',
    Alarm: 'Alarm',
    Driver: 'Customer',
    Vehicle: 'Vehicle',
    Invoice: 'Invoice',
    ConditionalInstance: 'Alarm',
    Subscription: 'Subscription',
    ReservationDriver: 'Reservation',
    reservations: 'Reservations',
    set_profile_image: 'Set as profile image',
    upload_image: 'Upload Image',
    profile_image: 'Profile Image',
    image_upload_success: 'Image uploaded successfully',
    upload_picture: 'Uploading a picture',
    archive: 'Archive',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday: 'Sunday',
    revenue: 'Revenue',
    all: 'All',
    order: 'Order',
    discount: 'Discount',
    MANDATORY: 'Mandatory',
    OPTIONAL: 'Optional',
    DELIVERY: 'Delivery',
    all_time: 'All the time',
    rules: 'Rules',
    create: 'Create',
    id_slug: 'ID Slug',
    max_long: 'Maximum "%{max_long}" characters',
    min_long: 'Minimum "%{min_long}" characters',
    credits: 'Credits',
    end_date: 'End date',
    start_date: 'Start date',
    required_check: 'Field must be checked',
    updated_successfully: 'Updated successfully',
    close: 'Close',
    enter_date: 'Enter Date',
    date: 'Date',
    finish: 'Finish',
    download: 'Download',
    images: 'Images',
    duplicate: 'Duplicate',
    leave_page: 'Leave This Page',
    no_results: 'No results found',
    enter_keywords: 'Enter keywords for search',
    owner: 'Owner',
    share: 'Share',
    shared: 'Shared',
    private: 'Private',
    phone: 'Phone',
    basic_info: 'Basic Information',
    full_name: 'Full Name',
    date_of_birth: 'Date Of Birth',
    role: 'Role',
    invite_code: 'Invite Code',
    email: 'Email',
    state_province: 'State/Province',
    zip_code: 'Postal Code',
    actions_needed: 'Actions Needed',
    accept: 'Accept',
    filter: 'Filter',
    filters: 'Filters',
    time: 'Time',
    published: 'Published',
    column: 'Column',
    introduction: 'Introduction',
    documentation: 'documentation',
    group_by: 'group by',
    for: 'for',
    include_archived: 'Include archived',
    invoice_status: 'Invoice Status',
    no_data: 'No data',
    generic_error: 'There was an unexpected error processing the request. Please try again.',
    ruleset_name: 'Ruleset Name',
    create_ruleset: 'Create Ruleset',
    missing: 'Missing',
    form_error: 'Validation of incoming data failed.',
    background_process:
      'Records are being processed in the background. Status will be reflected in a few moments.',
    update_information: 'Update Information',
    enabled: 'Enabled',
    disabled: 'Disabled',
    type: 'Type',
    basic_information: 'Basic Information',
    accounting: 'Accounting',
    default_price: 'Default Price',
    copy_of: 'Copy of %{name}',
    week_format: 'Week %{date}',
    max_length: 'Value should not exceed %{len} character in length.',
    unshare: 'Unshare',
    select_type: 'Select a Type',
    company: 'Company',
    individual: 'Individual',
    update_status: 'Update Status',
    import_csv: 'Import CSV',
    payment_method: 'Payment Method',
    not_supported: 'Not supported',
    by_fleet_owner: 'by Fleet Owner',
    by_fleet: 'by Fleet',
    'n/a': 'N/A',
    user_groups: 'User Groups',
    lm_name: 'Launch Mobility, Inc.',
    all_rights_reserved: 'All rights reserved.',
    report_type: 'Report Type',
    scheduled: 'Scheduled',
    note: 'Note',
  },
  fleets: {
    fleet: 'Fleet',
    fleets: 'Fleets',
    select_fleet: 'Select a Fleet',
  },
  locations: {
    fleet_disclaimer:
      'When sharing vehicles with Business partners, the location must be theirs to guarantee logistics, please create them based on the info provided offline by that partner.',
    title: 'Locations',
    deleted: 'Zone has been deleted successfully!',
    delete_message: 'Are you sure?',
    delete_message_description: 'Do you want to delete "%{name}" zone?',
    remove_message_description: 'Do you want to remove this location?',
    create: 'Create new location',
    details_title: 'Location Details',
    zone_name: 'Zone name',
    address: 'Address',
    country: 'Country',
    state: 'State',
    city: 'City',
    map: 'Map',
    zip_code: 'Postal Code',
    time_zone: 'Time Zone',
    location_info: 'Location Info',
    update_info: 'Update',
    edit: 'Edit locations',
  },
  tableColumns: {
    id: 'ID',
    name: 'Name',
    role: 'Role',
    email: 'Email',
    phone: 'Phone',
    active: 'Active',
    status: 'Status',
    actions: 'Actions',
    first_name: 'Name',
    quantity: 'Quantity',
    last_name: 'Last Name',
    description: 'Description',
    organization: 'Organization',
    end: 'End',
    file: 'File',
    type: 'Type',
    tasks: 'Tasks',
    title: 'Title',
    alarm: 'Alarm',
    behaviour: 'Behaviour',
    action: 'Action',
    start: 'Start',
    vehicle: 'Vehicle',
    link_to: 'Link to',
    priority: 'Priority',
    assigned: 'Assigned',
    due_date: 'Due Date',
    customer: 'Customer',
    location: 'Location',
    related_to: 'Related To',
    creation_date: 'Creation Date',
    expiration_date: 'Expiration Date',
    vehicle_group: 'Service Group',
    assignee: 'Assignee',
    end_reserved: 'End Reserved',
    start_reserved: 'Start Reserved',
    registration: 'Registration Status',
    document_type: 'Document Type',
    recurring_payment: 'Recurring Payment',
    next_payment: 'Next Payment',
    step: 'Step',
    start_time: 'Start Time',
    end_time: 'End Time',
    details: 'Details',
    subscription: 'Subscription',
    period: 'Period',
    service: 'Service',
    invoice_status: 'Invoice Status',
  },
  dashboard: {
    title: 'Dashboard',
    noc_sync: 'Sync',
    vehicles: 'Vehicles',
    time_zone: 'Time Zone',
    periods_title: 'Periods',
    service_area: 'Fleet',
    vehicle_groups: 'Service Group',
    noc_map_title: 'Reservations Map',
    reservation_status: 'Reservation Status',
    noc_calendar_title: 'Reservation Calendar',
    noc_vehicle_filter: 'Search vehicle',
    noc_date_range_filter: 'Date Range',
    noc_change_vehicle: 'Change Vehicle',
    noc_change_times: 'Change Times',
    noc_go_to_subscription: 'Go to subscription',
    noc_go_to_reservation: 'Go to reservation',
    vehicle_timezone: 'Vehicle / Time Zone',
    vehicles_reservations: 'Vehicles & Reservations',
    vehicle_group_location: 'Service Group / Location',
    vehicle_group_location_service_area: 'Service Group / Location / Fleet',
    pending_reservations_banner_text:
      'Some pending reservations are awaiting confirmation of additional requirements.',
    go_to_reservations: 'Go to Reservations',
    statistics: {
      percentage: '%',
      in_progress: 'In Progress',
      service_area: 'Fleet',
      vehicle_group: 'Service Group',
      available: 'Available',
      for_customers: 'For Customers',
      available_description: 'Vehicles available for customers to reserve',
      customer_in_progress: 'In-Progress',
      customer_in_progress_description: 'Vehicles with customer “in progress” reservations',
      customer_late_check_in: 'Late Check-In',
      customer_late_check_in_description:
        'Vehicles with a customer reservation but have not checked in',
      customer_late_return: 'Late Return',
      customer_late_return_description:
        'Vehicles with customer reservations past its checkout time',
      customer_upcoming: 'Upcoming',
      customer_upcoming_description: 'Number of future customer reservations close to start time',
      employee_in_use: 'In-Use',
      employee_in_use_description:
        'Vehicles currently reserved or in an in-progress employee reservation',
      employee_late_return: 'Late Return',
      employee_late_return_description:
        'Vehicles with employee reservations past its checkout time',
      other_orgs_in_use: 'In-Use',
      other_orgs_in_use_description:
        'Vehicles currently reserved or in an in-progress by other organizations',
      other_orgs_late_return: 'Late Return',
      other_orgs_late_return_description:
        'Vehicles with reservations in other orgs past its checkout time',
      utilized: 'Utilized',
      utilized_description: 'Vehicles with customer “in progress” reservations',
      online: 'Online',
      online_description:
        'Vehicles with customer reservation + vehicles available for customers to reserve',
      utilized_percentage_description: 'Percentage of active vehicles that are utilized',
      reserved: 'Late Check-in',
      reserved_description: 'Vehicles with a customer reservation but have not checked in',
      upcoming: 'Upcoming',
      upcoming_description: 'Number of future reservations close to start time',
      offline: 'Unavailable',
      offline_description:
        'Vehicles that are not available for customer reservations (excluding retired)',
      total: 'Total',
      total_description: 'Sum of “online” + “offline” vehicles',
      offline_percentage_description: 'Percentage of vehicles “offline” ',
      late_return: 'Late Return',
      late_return_description: 'Vehicles with reservations past its checkout time',
      vehicles_description: 'Vehicles by status (excluding retired)',
      reservations_description: 'Customer & employee reservations',
      service_area_description: 'Fleet assigned to the vehicles',
      vehicle_group_description: 'Service Group assigned to the vehicles',
    },
    actions: {
      title: 'Actions',
      delivery: 'Delivery',
      return: 'Return',
      needs_approval: 'Needs Approval',
      late_payment: 'Late Payment',
      pending_actions: 'Pending Actions',
      subscription_id: 'Subscription ID',
      step: 'Step',
      source: 'Source',
      source_id: 'Source Id',
      qualification: 'Qualification',
      requirements: 'Requirements',
      last_activity: 'Last Activity',
      started_time: 'Time Started',
      modify_time: 'Last Modified',
    },
    search_user: 'Search user',
    search_service_area: 'Search fleet',
    search_vehicle_group: 'Search service group',
    search_vehicle: 'Search vehicle',
    search_period_status: 'Search period status',
    search_reservation_status: 'Search reservation status',
    search_location: 'Search location',
    buffer_info:
      'Buffer\nReservation: {{reservation_id}}\nUser: {{username}}\nStart Buffer: {{start_buffer}}\nEnd Buffer: {{end_buffer}}',
    error: {
      USAGETIMERANGEERROR:
        'The range is out of limit. Please try a smaller one, or contact support to increase the limit.',
    },
  },
  statistics: {
    available: 'Online',
    inprogress: 'Utilized',
    reserved: 'Reserved',
    upcoming: 'Upcoming',
    offline: 'Offline',
    total: 'Total',
    in_return: 'In Return',
    in_progress: 'In Progress',
    in_delivery: 'In Delivery',
    late_return: 'Late Return',
  },
  bill: {
    title: 'Bills',
    details: 'Billing Details',
    add_payment: 'Add Payment Method',
    select_payment_placeholder: 'Please select a payment method',
  },
  receivable: {
    billing_information: 'Billing Information',
    billing: 'Billing',
    billing_details: 'Billing Details #%{id}',
    invoice: 'Invoice',
    statement: 'Statement Entry',
    from: 'From',
    to: 'To',
    source: 'Source',
    completed_on: 'Completed on',
    modified_on: 'Last modified on',
    due_date: 'Due date',
    processed_datetime: 'Processed Date & Time',
    due_datetime: 'Due Date & Time',
    total_invoiced: 'Total Invoiced',
    total_paid: 'Total Paid',
    amount_due: 'Amount Due',
    edit_invoice: 'Edit Invoice Information',
    invoice_ref: '%{status} - Account Statement',
    total_amount: 'Total Amount',
    billed_items: 'Billed Items',
    invoice_items: 'Invoice Items',
    statement_items: 'Entry items',
    customer: 'Customer',
    reference: 'Reference',
    billing_creation_datetime: 'Billing creation date',
    total: 'Total',
    reservation: 'Reservation',
    billing_preview: 'Billing Preview',
    billing_logs: 'Billing Logs',
    billing_items: 'Billing Items',
    add_new_item: 'Add new item',
    delete_item_message: 'Are you sure you want to delete this item?\nYou can’t undo this.',
    unit_price: 'Unit Price',
    quantity: 'Quantity',
    payment_information: 'Payment Information',
    paid_with_credits: 'Paid with credits',
    total_preauth: 'Total Preauth',
    add_payment: 'Add Payment Method',
    delete_billing_item: 'Delete Billed item',
    delete_invoice_item: 'Delete Invoice item',
    delete_statement_item: 'Delete Entry item',
    submit_title: 'Submit invoice',
    submit_msg:
      'When Submitted, this invoice will be seen by your Partner or Customer. Do you still want to Submit it?',
    unit: 'Unit',
    total_billed: 'Total Billed',
    total_tax: 'Total Tax',
    subtotal: 'Subtotal',
    send_customer: 'Email to Customer',
    send_requester: 'Email to Requester',
    process_balance: 'Process Balance',
    statuses: {
      PAID: 'Paid',
      DRAFT: 'Not submitted',
      QUOTE: 'Quote',
      UNPAID: 'Unpaid',
      PENDING: 'Pending',
      PARTIAL: 'Partial',
      OVERPAID: 'Overpaid',
      CANCELLED: 'Cancelled',
      UNPAIDINPROGRESS: 'Payment in progress',
      VOID: 'Void',
    },
  },
  invoice: {
    updated_success: 'Invoice has been updated successfully.',
    discard_title: 'Discard invoice',
    discard_msg: 'Are you sure about deleting this invoice?',
    save_title: 'Save invoice',
    save_msg:
      'This invoice will be saved internally, if you want to send it to your Partner or Customer please use the option Submit.',
    submit_title: 'Submit invoice',
    submit_msg:
      'When Submitted, this invoice will be seen by your Partner or Customer. Do you still want to Submit it?',
    confirm_publish: 'Are you sure you want to submit this invoice?',
    deleted_successfully: 'Invoice has been discarded.',
    title: 'Invoices & Billing',
    invoices: 'Invoices',
    invoice_information: 'Invoice Information',
    source_type: {
      ReservationDriver: 'Reservation',
      OwnerVehicleGroup: 'Fleet',
    },
    successfully_refunded: 'Status will be updated in a few moments.',
    to: 'To',
    tax: 'Tax%',
    date: 'Date',
    unit: 'Unit',
    from: 'From',
    name: 'Name',
    paid: 'Paid',
    total: 'Total',
    method: 'Method',
    source: 'Source',
    status: 'Status',
    billing: 'Billing',
    invoice: 'Invoice',
    payment_flow: 'Payment Flow',
    payments_out: 'Payments Out',
    payments_in: 'Payments In',
    actions: 'Actions',
    preauth: 'Preauth',
    in_and_out: 'In&Out',
    due_date: 'Due date',
    reference: 'Reference',
    filter_by_in_and_out: 'Filter by In&Out',
    invoice_and_billing: 'Invoice <br /> Billing',
    subtotal: 'Subtotal',
    refunded: 'Refunded',
    due_time: 'Due Time',
    quantity: 'Quantity',
    total_tax: 'Total Tax',
    past_time: 'Past Time',
    edit_item: 'Edit item',
    detail: 'Invoice details',
    total_paid: 'Total Paid',
    amount_due: 'Amount Due',
    unit_price: 'Unit Price',
    description: 'Description',
    add_new_item: 'Add new item',
    mark_as_paid: 'Mark as Paid',
    quantity_unit: 'Quantity/Unit',
    invoice_items: 'Invoice Items',
    total_preauth: 'Total Preauth',
    total_invoice: 'Total Invoiced',
    total_invoiced: 'Total Invoiced',
    due_datetime: 'Due Date & Time',
    delete_item: 'Delete Invoice item',
    paid_with_credits: 'Paid with credits',
    edit_invoice: 'Edit Invoice Information',
    only_late_payments: 'Only late payments',
    payment_information: 'Payment Information',
    customer_and_partners: 'Partner / Customer',
    processed_datetime: 'Processed Date & Time',
    search_by_subs: 'Search by Subscription ID',
    published_successfully: 'Invoice sent successfully',
    updated_successfully: 'Invoice updated successfully',
    created_draft: 'Invoice saved successfully as draft',
    created_successfully_draft: 'Invoice created successfully as a draft',
    confirm_mark_as_paid: 'Are you sure you want to mark these invoices as paid?',
    delete_item_message: 'Are you sure you want to delete this item?\nYou can’t undo this.',
    delete_invoice_item_success_msg: 'Invoice item deleted successfully',
    added_invoice_item_success_msg: 'New invoice item added successfully',
    updated_invoice_item_success_msg: 'Invoice item successfully updated',
    create: 'Create',
    search_customer: 'Search customer',
    customer: 'Customer',
    details: 'Invoice Details ID#%{id}',
    preview: 'Invoice Preview',
    logs: 'Invoice Logs',
    items: 'Invoice Items',
    total_info: 'Total: $%{total}',
    payment: 'Payment',
    paid_amount: 'Paid: $%{amount}',
    payment_id: 'Payment ID',
    send_by_email: 'Send by Email',
    send_customer: 'Email to Customer',
    send_requester: 'Email to Requester',
    send_email_success: 'Invoice successfully sent',
    refund: 'Refund',
    total_refunded: 'Total to be refunded',
    refund_description_1: 'Are you sure you want to refund? If you are sure please write the word',
    refund_description_2: 'REFUND',
    refund_description_3: 'in the field below.',
    download_as_pdf: 'Download As PDF',
    process_balance: 'Process Balance',
    processing_balance_msg: 'Submitted attempt to process balance',
    create_new_invoice: 'Create New Invoice',
    invoice_created_successfully: 'Invoice created successfully',
    process_draft_invoices_msg: 'Draft Invoices cannot be processed, please first unselect them',
    authorization_holds_title: 'Hold',
    wizard: {
      title: 'Invoice Creation',
      basic_info: 'Basic Info',
      details: 'Invoice Details',
      name_or_id: 'Name or ID',
    },
    view_all: 'View All',
  },
  vehicle: {
    error: { UNAUTHORIZED: 'The user no longer has access to this vehicle.' },
    status: 'Status',
    status_change_success_title: 'Your request has been successfully processed.',
    status_change_success_message: 'Access details from any part of the vehicle widgets.',
    status_change_error_title: 'We were unable to process your request.',
    status_change_error_message:
      'We had a problem processing your request. Please close this message and try again.',
    share_unsharing_title: 'Sharing a Vehicle when in Unsharing Process',
    share_unsharing_msg:
      'This action will leave the Vehicle back with the same arrangements your Service partner previously had on it.',
    bulk_unshare_confirm_title: 'Unsharing will produce these next consequences on Reservations:',
    bulk_unshare_confirm_warning: 'Are you sure you want to Unshare anyways?',
    bulk_unshare_confirm_with_grace: [
      'All the <b>Driver Reservations</b> within a %{gracePeriod}-Day Grace Period would be kept.',
      'Any Reservation beyond that date will be canceled.',
      '<b>Employees Reservations</b> will be canceled immediately.',
      'This Vehicle will go into <b>Unsharing</b> process till the Grace Period is finished and won’t be available for new Reservations.',
    ],
    bulk_unshare_confirm_with_no_grace: [
      'All the <b>Driver Reservations</b> will be canceled immediately, excepting the ones already in progress.',
      '<b>Employees Reservations</b> will be canceled immediately.',
    ],
    unshare_disclaimer:
      'Some vehicles could have these Services previously removed from the list of Shared Services, hence those vehicles will remain as “Unsharing” but will be active till the last Reservation ends.',
    description: 'Track, share, and update the status of vehicles in your fleet.',
    activation: 'Vehicle Activation',
    trim: 'Trim',
    vin: 'VIN',
    color: 'Color',
    title: 'Vehicle',
    return_date_not_set: 'Return Date Not Set',
    date_range_description:
      "You can select the checkboxes to use the default time, or set it manually using the 'Start Status' and 'End Status' fields.",
    no_scheduled_completion_date: 'This vehicle has no scheduled completion date.',

    options: 'Options',
    end_date: 'End date',
    available_services: 'Available Services',
    available_partners: 'Available Partners',
    selected_services: 'Selected Services',
    selected_partners: 'Selected Partners',
    unshared_services: 'Unshared Services',
    unshared_partners: 'Unshared Partners',
    edited_success_msg: 'Vehicle edited successfully',
    update_information: 'Update Information',
    update_vehicle_information: 'Update vehicle information',
    start_now: 'Start now',
    connection: 'Connection',
    start_date: 'Start date',
    offline_reason: 'Reason',
    immediately: 'Immediately',
    update_info: 'Update',
    picture_name: 'Picture name',
    create: 'Create new vehicle',
    service_area: 'Fleet',
    services: 'Services',
    upload_image: 'Upload Image',
    serch_vehicle: 'Search vehicle',
    profile_image: 'Profile Image',
    missing: 'Missing requirements',
    update_sharing: 'Update Sharing',
    select_partner: 'Select service',
    upload_picture: 'Uploading a picture',
    vehicle_group: 'Service Group',
    service_group: 'Service Group',
    make_model: 'Make/Model',
    vehicle_id_label: 'Vehicle ID',
    vehicle_type_label: 'Type',
    license_plate: 'License Plate',
    vehicle_details: 'Vehicle Details',
    vehicle_groups: 'Service Groups',
    vehicle_images: 'Images',
    select_fleet: 'Select a Fleet',
    details_title: 'Vehicle Details',
    filter_by_status: 'Filter by status',
    filter_by_service: 'Filter by Service',
    filter_by_partner: 'Filter by Partner',
    vehicle_group_name: 'Service Groups Name',
    add_vehicle_group: 'Add new service groups',
    filter_by_vehicle_group: 'Filter by %{type}',
    change_vehicle_status: 'Update Vehicle Status',
    change_vehicles_status: 'Change vehicle status',
    specific_date_time: 'at a specific date and time',
    share_n_unshare: 'Share & Unshare selected vehicles to Services',
    share_n_unshare_to_partners: 'Share & Unshare selected vehicles to Partners',
    share_n_unshare_description:
      'Ensure the vehicles to be shared have the status “Active”, then select in the dropdown the Fleet shared with the Service, finally click on “Share” or “Unshare”, and select the Service(s).',
    share_n_unshare_description_partners:
      'Ensure the vehicles to be shared have the status “Active”, then select in the dropdown the Fleet shared with the Partner, finally click on “Share” or “Unshare”, and select the Partner(s).',
    bulk_unshare_title: 'What services do you want to unshare these vehicles to?',
    bulk_unshare_title_partners: 'What partners do you want to unshare these vehicles to?',
    update_sharing_title: 'What services do you want to share these vehicles to?',
    update_sharing_title_partners: 'What partners do you want to share these vehicles to?',
    multiple_status_changed:
      'Vehicles updating in the background. Status will be reflected in a few moments',
    share_offline_message:
      "Some vehicles you're sharing are inactive, please update the status before continuing.",
    multiple_update_sharing_changed:
      'Vehicles updating in the background. Changes will be reflected in a few moments',
    change_status: 'Update Status',
    date_range: 'Date Range',
    price: 'Price',
    number_of_seats: 'Number of seats',
    refresh_gps_success: 'Vehicle coordinates has been requested!',
    lock_success: 'The vehicle has been locked!',
    unlock_success: 'The vehicle has been unlocked!',
    action_success: 'Command sent to the vehicle',
    identify_success: 'The vehicle has been identified!',
    unlock_enable_success: 'The vehicle has been unlocked and enabled!',
    select_broker: 'Select a broker',
    edit_broker: 'Edit broker',
    edit_services: 'Edit services',
    vehicle_services: 'Vehicle Services',
    select_service_before_add_to_service_area: 'First select a service before add it to fleet',
    select_service_before_remove_from_service_area:
      'First select a service before remove it from to fleet',
    no_pending_requirements: 'No pending requirements',
    reason_description: 'Description (140 characters limit)',
    service_removed_successfully: 'Service removed successfully',
    group_activation: 'Do you want to make this group available to customers?',
    group_activation_tooltip:
      'By enabling this toggle, you will share this service group to logged users.',
    group_activation_description:
      'By enabling this toggle, you will share this service group to logged users.',
    include_anonymous: 'Do you want to make this group available to unidentified customers?',
    include_anonymous_tooltip:
      'By enabling this toggle you will share this service group to unregistered or unlogged users.',
    include_anonymous_description:
      'By enabling this toggle you will share this service group to unregistered or unlogged users.',
    vehicle_ativation_title: 'Do you want to make this vehicle available to end-users?',
    vehicle_ativation_description:
      '* Scheduling a vehicle to be active is currently permanent. You may only schedule a car to be active further in advance once you have set an initial active date. You can set alternative statuses such as "In Shop" for those future dates directly on the vehicle page. The car will not be available to customers unless it is active AND the associated service group is also active.',
    vehicle_general_information: 'Vehicle General Information',
    assigned: 'assigned',
    available: 'available',
    empty_services: 'No services has been assigned',
    current_vehicle: 'Current Vehicle',
    change_vehicle: 'Change Vehicle',
    vehicle_changed_successfully: 'Vehicle changed successfully',
    available_to_customers: 'Available for Customers',
    unlock_and_enable_confirm: 'Are you sure you want to Unlock and enable?',
    import_csv: {
      title: 'Import CSV',
      description: 'Add new vehicles information by importing a .CSV in the prescribed format.',
      max_rows: 'Maximum 100 rows per upload',
      upload_text: 'Drag and drop your .CSV file to import or',
      browse: 'browse',
      download_text: 'Download our CSV template in order to import data in a readable format.',
      download_csv: 'Download CSV',
      import_external_data: 'Import external vehicle data',
      successfull_file: 'file_name.csv has been uploaded successfully',
      error_file: 'file_name.csv has been uploaded successfully',
      matched_text: 'Matched to the',
      field: 'field',
      row_detected: 'row detected',
      vehicle_type_id: 'Vehicle Type Id',
      name: 'Name',
      color: 'Color',
      vin: 'VIN',
      price: 'Price',
      seats: 'Seats',
      details: 'Details',
      license_plate: 'License Plate',
      vehicle_group_id: 'Fleet Id',
      fleet_id: 'Fleet Id',
      csv_fields_required: 'Service Group Id, Fleet Id and Vehicle Type Id are required columns',
      invalid_file: 'Invalid file',
      upload_success: 'has been uploaded successfully',
      success_import:
        'Vehicles creating in the background. Vehicles will be reflected in a few moments',
    },
    include_retired: 'Include Retired',
    include_archived: 'Include archived',
    delete: 'Delete Vehicle',
    delete_message: 'Are you sure you want to delete the vehicle?',
    delete_success_msg: 'Vehicle deleted successfully',
    wizard: {
      vin: 'VIN',
      name: 'Name',
      color: 'Color',
      price: 'Price',
      fleet: 'Fleet',
      seats: 'Number of seats',
      description: 'Description',
      asset_class: 'Asset Class',
      vehicle_type: 'Vehicle Type',
      license_plate: 'License Plate',
      vehicle_details: 'Vehicle Details',
    },
    unshare_title: 'Unshare vehicle',
    unshare_description: 'Do you wish unshare this vehicle with the selected service?',
    statuses: {
      title: 'Offline Times',
      status: 'Status',
      start_date: 'Start date',
      end_date: 'End date',
      reason: 'Reason',
      description: 'Description',
      tooltip:
        'Since this table only shows timeframes where the vehicle is “Offline”, any timeframe in between means the vehicle is “Active”.',
    },
  },
  user_groups: {
    create: 'Create user group',
    general_info: 'General Information',
    business_info: 'Business Information',
    id: 'ID',
    name: 'Name',
    actions: 'Actions',
    default_role: 'Default Role',
    add_user_group: 'Add user group',
    user_group_type: 'User Group Type',
    assigned_groups: 'Groups already assigned to customer',
    delete_user_group: 'Delete user group',
    delete_user_group_confirm: 'Are you sure you want to delete the user group?',
    delete_success: 'User group deleted successfully',
    yes: 'Yes',
    cancel: 'Cancel',
    select_vehicle_group: 'Select default service group',
    update_user_group: 'Update User Group',
    update_user_group_success: 'User Group updated successfully',
    types: {
      EMPLOYEE: 'Employee',
      DRIVER: 'Driver',
    },
    roles: {
      admin: 'Admin',
      service_manager: 'Service Manager',
      group_manager: 'Group Manager',
      fleet_manager: 'Fleet Manager',
      operator: 'Operator',
      driver: 'Driver',
      driver_loaner: 'Driver Loaner',
      driver_crew: 'Driver crew',
      operations_lead: 'Operations Lead',
      driver_business: 'Driver Business',
    },
    parent: {
      name: 'Name',
      type: 'Type',
      status: 'Status',
      available: 'Available parent groups',
      parent_groups: 'Parent Groups',
      edit_parent_groups: 'Edit Parent Groups',
      select: 'Select the parent group to add it to your user group',
      empty: 'First select a parent before add it to user group',
      empty_parents: 'No records to display',
    },
    dealer_created: 'Dealer created successfully',
    create_dealer: 'Create Dealer',
    dealer: 'Dealer',
    search_dealer: 'Search Dealer',
    update_dealer: 'Update Dealer',
    delete_dealer: 'Delete Dealer',
    delete_dealer_confirm: 'Are you sure you want to delete the dealer?',
    vehicle_group: 'SG',
    owner_vehicle_group: 'FL',
    group_type: 'Group Type',
    dealers: 'Dealers',
    dealer_basic_info: 'Basic Information',
    vehicle_groups: 'Service Groups',
    dealer_details: 'Dealer Details',
  },
  skus: {
    default_no_location: 'Tax rate if no location found',
    default_tax_rate_tooltip:
      'This value applies only when a location is not specified on the ruleset',
    auto: 'Auto',
    price: 'Price',
    title: 'SKUs',
    sku_details: 'SKU Details',
    sku_accounting: 'SKU Accounting',
    ad_hoc: 'Ad-hoc',
    skus_type: 'Type',
    automated_sku: 'Automated SKU',
    manual_sku: 'Manual SKU',
    account_type: 'Account Type',
    update_information: 'Update Information',
    tax_type: 'Tax Type',
    default_tax_rate: 'Default Tax Rate',
    created: 'Sku created successfully',
    units: 'Units',
    automatic: 'Automatic',
    manual: 'Adhoc (Manual)',
    create: 'Create a new SKU',
    behaviour: 'Behaviour',
    deleted: 'Sku archived successfully',
    updated: 'Sku updated successfully',
    create_sku: 'Create SKU',
    update_sku: 'Update SKU',
    sku_id: 'SKU ID',
    update_sku_info: 'Update SKU info',
    accounting: 'Accounting',
    tax_is_set_to_zero: 'Tax is set to 0%',
    tax_zip_code: 'Sales tax by customer Postal code',
    basic_info: 'Basic information',
    archive: 'Archive',
    unarchive: 'Unarchive',
    activate: 'Activate',
    activate_sku: 'Activate SKU',
    delete_sku: 'Archive Sku',
    delete_sku_msg: 'Are you sure you want to archive this sku?',
    type: 'Type',
    name: 'Name',
    invoice_description: 'Invoice Description',
    note: 'Note',
    change_settings: 'Change setting',
    change_settings_manual:
      'Are you sure you want to change the configuration? Remember that, allowing this SKU to be use manually, you will be able to add this SKU on an invoice.',
    change_settings_automated:
      'Are you sure you want to change the configuration? Remember that as automated rule, you will be able to use this rule when creating your RuleSets',
    tax_types: {
      DEFAULT: 'Use default',
      EXEMPT: 'Tax exempt',
      EXTERNAL: 'Use external',
      PERLOCATION: 'Use per location',
    },
    wizard: {
      accounting_title: 'How do you want to show this SKU in your accounting?',
      behaviour_title: 'Please select at least one option',
      revenue_label: 'Revenue',
      revenue_description: 'Income-generating item or activity',
      discount_label: 'Expense',
      discount_description: 'Discount or credit assigned to an item, activity or account',
      accounting_type: 'Account type',
      select_account_type: 'Select an account type',
      service_revenue: 'Services Revenue',
      penalties_and_fee_revenue: 'Penalties and fee revenue',
      passthrough_revenue: 'Passthrough Revenue',
      taxes: 'Taxes',
      select_tax_type: 'Select tax type',
      tax_default: 'Use default',
      tax_exempt: 'Tax exempt',
      tax_use_external: 'Use external',
      tax_per_location: 'Use per location',
      invoice_description: 'Invoice description',
      invoice_note: 'Notes',
      type: 'Type',
      day: 'Day',
      hour: 'Hour',
      minute: 'Minute',
      automated_sku_label: 'Automate this SKU',
      automated_sku_description: 'Automated rules can be used when creating your rule sets.',
      manually_sku_label: 'Use this SKU manually',
      manually_sku_description: 'A manual SKU can be added to invoices on an ad hoc basis.',
      default_price: 'Default Price',
      hold_label: 'Hold',
      hold_description: 'Represent the authorize hold fees',
    },
    edit_accounting: 'Edit Accounting',
    edit_accounting_info: 'Edit Accounting Information',
    category_fee: 'Fee',
    category_credit: 'Credit',
    category_hold: 'Hold',
  },
  user_group: {
    title: 'User Group ID',
    see_all_user_groups: 'See All User Groups',
    add_user_group: 'Add New User Group',
    widget_title: 'User Group',
    see_all_dealers: 'See All Dealers',
    add_dealer: 'Add New Dealer',
  },
  pricing_rules: {
    title: 'Pricing Rules',
    edit: 'Edit Pricing Rules',
    add_new_rule: 'Add new rule',
    no_pricing_rules: 'There are no pricing rules assigned',
    ruleset_added_successfully: 'Ruleset added successfully',
    ruleset_removed_successfully: 'Ruleset removed successfully',
    ruleset_updated_successfully: 'Ruleset updated successfully',
  },
  vehicle_groups: {
    save_disclaimer: 'If you select a Ruleset, you MUST click SAVE before continuing',
    unsaved_changes: 'You forgot to click the option "SAVE" after selecting the Ruleset',
    status: {
      ACTIVE: 'Shared',
      INACTIVE: 'Inactive',
      BLOCKED: 'Blocked',
      UNSHARING: 'Unsharing',
    },
    on_unshare: '(Unsharing Process)',
    fleet_disclaimer:
      'Some vehicles could have these Services previously removed from the list of Shared Services, hence those vehicles will remain as “Unsharing” but will be active till the last Reservation ends',
    unshare_tooltip_title: 'Unsharing Process',
    unshare_tooltip_msg:
      'it means this Service still has Reservations to be finished with this vehicle, in order to be totally Unshared.',
    future_disclaimer:
      'This service got active again after recently being Unshared. The vehicle will behave as usual and will be part again of the Service after %{startTime}. You’ll be able to Unshared this service again after that date also.',
    add: 'Add',
    delete: 'Delete',
    delete_vehicle_group: 'Delete Service Group',
    delete_vehicle_group_msg:
      'Are you sure you want to delete this service group? You can’t undo this.',
    delete_vehicle_group_success: 'Service Group deleted successfully',
    delete_vehicle_group_error: 'Unable to delete the Service Group',
    location: 'Location',
    logs: '%{type} logs',
    search: 'Search %{type}',
    details: '%{type} Details',
    services: 'Services',
    partners: 'Partners',
    service_area: 'Fleet',
    service_areas: 'Fleets',
    images: 'Images',
    create: 'Create New Fleet',
    new_service_area: 'New Fleet',
    edit_service_area: 'Edit Fleet',
    vehicle_group: 'Service Group',
    vehicle_groups: 'Service Groups',
    service_areas_title: 'Service Areas',
    fleet_description:
      'Fleets are collections of Vehicles and Locations that you share with your affiliated services.',
    fleet_description_partners:
      'Fleets are collections of Vehicles and Locations that you share with your affiliated partners.',
    customer_access: 'Customer Access',
    pricing_rule_set: 'Pricing Ruleset',
    edit_rrs: 'Edit Reservation Ruleset',
    add_service_group: 'Add Service Group',
    details_title: 'Service Group Details',
    available_services: 'Available Services',
    update_information: 'Update Information',
    vehicle_group_info: 'Service Group Info',
    edit_vehicle_groups: 'Edit service groups',
    available_locations: 'Available Locations',
    reservations_ruleset: 'Reservation Ruleset',
    new_vehicle_groups: 'Create Service Group',
    identifier_name: 'Internal Identifier Name',
    update_vehicle_group: 'Update Service Group',
    update_service_area: 'Update Fleet',
    create_service_area: 'Create New Fleet',
    manage_service_groups: 'Manage Service Groups',
    no_locations: 'There are no locations assigned',
    vehicle_group_services: 'Selected Services',
    create_vehicle_groups: 'Create Service Group',
    reservations_ruleset_label: 'Reservation Ruleset',
    vehicle_group_locations: 'Service group locations',
    selected_locations: 'Selected Locations',
    service_area_name: 'Fleet {{name}} #{{id}} ',
    grant_access_to_services: 'Grant access to services',
    grant_access_to_partners: 'Grant access to partners',
    service_area_information: 'Fleet Information',
    vehicle_group_information: 'Service Group Information',
    service_area_general_info: 'Fleet General Info',
    service_added_successfully: 'Service added successfully',
    location_added_successfully: 'Location added successfully',
    location_removed_successfully: 'Location removed successfully',
    select_available_zone: 'Select a location for your services',
    select_available_zone_partners: 'Select a location for your partners',
    add_location_service_area: 'Please add locations to fleet',
    vehicle_groups_success_msg: 'Service groups %{action} successfully',
    vehicle_edited_success_msg: 'Vehicle edited successfully',
    groups_assigned_to_customers: 'Groups already assigned to customer',
    add_location_vehicle_group: 'Please add locations to service groups',
    select_service: 'First select a service before add it to fleet',
    add_service_service_area: 'Please add at least one service to fleet',
    add_location_message: 'First select a location before add it to fleet',
    remove_location_message: 'First select a location before remove it from fleet',
    location_description:
      'The location can be used as pick-up, drop-off, free-floating, or penalty zones.',
    location_description_fleet:
      'The location can be used as pick-up, drop-off, free-floating, or penalty zones. Reminder: when sharing vehicles with Business partners, the location must be theirs to guarantee logistics, please make sure they were created based on the info provided offline by that partner.',
    wizard_title_create_mode: 'New Service Group',
    wizard_title_edit_mode: 'Service group {{name}} #{{id}}',
    fleet_created_feedback: 'Fleet created successfully',
    fleet_updated_feedback: 'Fleet updated successfully',
    change_service_area:
      'By changing the fleet, all existing relationships to service organizations and customer service groups will be removed. You can reattach the vehicle after complete. Do you want to continue?',
    edit_services: 'Edit services',
    rule_set: 'Rule Set',
    reservation_ruleset: 'Reservation Ruleset',
    reservations_rulesets: 'Reservations Rulesets',
    vehicle_group_created: 'Service group created successfully',
    reservation_ruleset_added: 'Reservation ruleset added successfully',
    reservation_ruleset_updated: 'Reservation ruleset updated successfully',
    reservation_ruleset_deleted: 'Reservation ruleset removed successfully',
    user: 'User Service Groups',
    business_hours: {
      title: 'Business Hours',
      bh_rulesets: 'Business Hour Rulesets',
      edit_business_hours: 'Edit Business Hours',
      bh_ruleset_added: 'Business Hours ruleset added successfully',
      bh_ruleset_updated: 'Business Hours ruleset updated successfully',
      bh_ruleset_deleted: 'Business Hours ruleset removed successfully',
      business_hours_rule: 'Business Hours ruleset {{name}}',
      empty_bhr: 'There are no Business Hour Rulesets set up for this location',
    },
    unshare_title: 'Unshare fleet',
    unshare_description: 'Do you want to unshare this fleet?',
    unshare_success: 'Fleet updating in the background. Status will be reflected in a few moments',
  },
  vehicle_types: {
    title: 'Vehicle Types',
    vehicle_type: 'Vehicle Type',
    vehicle_type_images: 'Images',
    create_new_vehicle_type: 'Create new vehicle type',
    quick_specs: 'Quick Specs',
    engine_specs: 'Engine Specs',
    performance_specs: 'Performance Specs',
    year: 'Year',
    make: 'Make',
    model: 'Model',
    trim: 'Trim',
    category: 'Category',
    powertrain: 'Powertrain',
    asset_class: 'Asset class',
    msrp: 'MSRP',
    power: 'Power',
    range: 'Range',
    fuel_capacity: 'Fuel capacity',
    displacement: 'Displacement',
    cylinders: 'Cylinders',
    engine_type: 'Engine type',
    delete_confirm: 'Are you sure you want to delete',
    upload_image: 'Upload Image',
    profile_image: 'Profile Image',
    add_new_category: 'Add new category',
    electric: 'Electric',
    hybrid: 'Hybrid',
    gasoline: 'Gasoline',
    H2_fuel_cell: 'H2 Fuel cell',
    plugin_hybrid: 'Plug-in Hybrid',
    manual: 'Manual',
  },
  location: {
    edit: 'Edit',
    city: 'City',
    state: 'State',
    address: 'Address',
    create: 'Create',
    name: 'Zone Name',
    country: 'Country',
    location: 'Location',
    zip_code: 'Postal Code',
    add: 'Add a location',
    save: 'Save location',
    time_zone: 'Time Zone',
    heading_subtitle: 'Let’s create the boundaries of this zone.',
  },
  tasks: {
    tags: 'Tags',
    title: 'Tasks',
    single: 'Task',
    assignee: 'Assignee',
    edit: 'Edit task',
    creator: 'Creator',
    assigned: 'Assigned',
    view_all: 'View all',
    create: 'Create task',
    search: 'Search task',
    open_since: 'Open since',
    related_to: 'Related to',
    assigned_to: 'Assigned to',
    opened_since: 'Open since',
    task_created: 'Task created successfully',
    task_updated: 'Task updated successfully',
    tasks_placeholder: 'No records to display',
  },
  forms: {
    title: 'Forms',
    create: 'Create form',
    title_list: 'Form list',
    create_by: 'Create by',
    create_date: 'Create date',
    forms_placeholder: 'No records to display',
    cleanliness: 'cleanliness',
    experience: 'experience',
    vehicle_photo: 'vehicle_photo',
    vehicle_interior_photo: 'vehicle_interior_photo',
    driver_damage_inspection: 'driver_damage_inspection',
    fuel_capture: 'fuel_capture',
    event: 'event',
    comments: 'comments',
    damage_image: 'damage_image',
    damage_location: 'damage_location',
    clean_rating: 'clean_rating',
    clean_comment: 'clean_comment',
    experience_rating: 'experience_rating',
    experience_comment: 'experience_comment',
    vehicle_image: 'vehicle_image',
    reservation_driver: 'ReservationDriver',
    front_right: 'Front right',
    front_left: 'Front left',
    back_left: 'Back left',
    back_right: 'Back right',
    front_interior: 'Front interior',
    back_interior: 'Back interior',
    rate: 'Rate',
  },
  wizard: {
    next: 'Next',
    cancel: 'Cancel',
    are_you_sure: 'Are you sure?',
    back: 'Back to previous step',
    save_as_draft: 'Save as draft',
    save_and_exit: 'Save and exit',
    success_message: 'Created successfull',
    pending_changes: 'You have pending changes',
    make_changes: 'Are you sure you want to make this change?',
    titles: {
      create_vehicle: 'Create Vehicle',
      update_vehicle: 'Update Vehicle Details',
    },
    create_and_continue: 'Create And Continue',
    update_and_continue: 'Update And Continue',
    create: 'Create',
    edit_form: 'Edit Form',
    skip: 'Skip',
    save_changes: 'Save Changes',
  },
  account: {
    title: 'Account',
    verify: 'Verify',
    password: 'Password',
    settings: 'Settings',
    new_phone: 'New phone',
    new_email: 'New email',
    update_info: 'Update',
    new_password: 'New password',
    change_email: 'Change email',
    change_phone: 'Change phone',
    contact_info: 'Contact information',
    current_email: 'Current email',
    current_phone: 'Current phone',
    personal_info: 'Personal info',
    update_password: 'Update Password',
    change_password: 'Change password',
    current_password: 'Current password',
    verification_code: 'Verification Code',
    verify_phone_success: 'Mobile phone verified!',
    change_pwd_msg_1: 'Why do I see this message?',
    change_account_success: 'Account changed successfully',
    change_password_success: 'Password changed successfully',
    change_phone_msg_1: 'We have sent a 6-digit verification code to',
    change_phone_msg_2: 'Please enter the code below and click on "Verify".',
    change_phone_success: 'SMS Sent! Please enter the code below and click on "Verify".',
    change_email_success:
      'Email will be updated after verification. To verify click on the link in the email sent to your inbox.',
    change_pwd_msg_2:
      'In accordance with our security policies passwords must be renewed every 90 days. Please update it to regain access to your account.',
    password_matches:
      'Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and one special case Character.',
    mfa_required: 'MFA Required',
    mfa_description: 'Enter the two factor code generated or recovery code',
    mfa_code: 'Enter 6 digits code',
    mfa_verification_sent: 'Verification code sent',
    mfa_verify: 'Verify',
    mfa_generate_code: 'Generate code',
    mfa_error: 'Error in the verification code, try again.',
    change_email_remove_mfa:
      'After confirming your new email, you\'ll need to set up "Two-Factor Authetication" the next time you log in.',
  },
  alarm: {
    title: 'Alarm',
    add_task: 'Add task',
    alarm_id: 'Alarm ID #',
    open_since: 'Open since',
    current_information: 'Current Information',
    details: 'Alarm Details',
    create_date: 'Create Date',
    update_success_msg: 'Alarm updated successfully',
  },
  fields: {
    email: 'Email',
    phone: 'Phone',
    password: 'Password',
    last_name: 'Last Name',
    first_name: 'First Name',
    middle_name: 'Middle Name',
  },
  alarms: {
    types: 'Types',
    title: 'Alarms',
    status: 'Status',
    view_all: 'View all',
    priority: 'Priority',
    search: 'Search alarm',
    alarms_placeholder: 'No records to display',
    close_alarms: 'Close Alarms',
    multiple_close_msg:
      'Alarms updating in the background. Status will be reflected in a few moments',
  },
  reservations: {
    pending_action_required: 'Action Required:',
    pending_description:
      'This reservation is <strong>Pending</strong> and not yet confirmed due to incomplete requirements. Please choose how to proceed:',
    pending_bullet_1_title: 'Skip & Confirm: ',
    pending_bullet_1_desc: 'Manually approve this reservation now, skipping any remaining steps.',
    pending_bullet_2_title: 'Leave Pending: ',
    pending_bullet_2_desc:
      'Driver must finish the steps in the Mobile App or Web Reservation App to confirm.',
    leave_pending: 'Leave Pending',
    bypass_and_confirm: 'Skip & Confirm',
    skip_buffer: 'Skip vehicle buffer time',
    skip_buffer_tooltip:
      'Vehicles have a buffer time to allow room for cleaning, maintenance or related actions. If you skip it, you can accelerate the use of that vehicle in a new Reservation.',
    plate: 'Plate',
    vehicle: 'Vehicle',
    view_all: 'View all',
    location: 'Location',
    end_used: 'End Used',
    end_date: 'End Date',
    title: 'Reservations',
    create: 'Create Reservation',
    start_date: 'Start Date',
    start_used: 'Start Used',
    pickup: 'Pickup Location',
    dropoff: 'Dropoff Location',
    end_reserved: 'End Reserved',
    details: 'Reservation Details',
    start_reserved: 'Start Reserved',
    total_distance: 'Total Distance',
    end_reservation: 'End Reservation',
    basic_information: 'Basic Information',
    start_reservation: 'Start Reservation',
    create_reservation: 'Create Reservation',
    cancel_reservation: 'Cancel Reservation',
    edit_reservation: 'Edit Reservation',
    update_reservation: 'Update Reservation',
    create_new_reservation: 'Create New Reservation',
    reservation_updated: 'Reservation successfully updated.',
    reservation_created: 'Reservation successfully created.',
    reservation_started: 'Reservation successfully started.',
    broker_add_success: 'Broker added successfully to reservation.',
    broker_remove_success: 'Broker removed successfully.',
    reservation_ended: 'Reservation successfully ended.',
    reservation_canceled: 'Reservation successfully canceled.',
    end_reservation_msg: 'Are you sure you want to End reservation?',
    start_reservation_msg: 'Are you sure you want to Start reservation?',
    cancel_reservation_msg: 'Are you sure you want to Cancel reservation?',
    different_timezone: 'This vehicle is in {{time_zone}} current time {{time}}',
    details_title: 'Reservation',
    update_times: 'Update Times',
    logs: 'Reservation logs',
    action_buttons: {
      end: 'end',
      start: 'start',
      cancel: 'cancel',
      update: 'update',
      update_vehicle: 'update_vehicle',
    },
    edit_broker: 'Edit broker',
    used: 'Used',
    reserved: 'Reserved',
    bypass: 'Bypass customer rules',
    bypass_rules: 'Bypass rules',
    no_reservations: 'No records to display',
    include_all_services: 'Include all services',
    cancel_with_no_charge: 'Cancel with no charge',
    reservation_info:
      'Status: {{status}}\nReservation: {{reservation_id}}\nUser: {{username}}\nStart Used: {{start_date}}\nEnd Used: {{end_date}}\nEnd Buffer: {{end_buffer}}',
    reservation_info_offline:
      'Reason: {{reason}}\nDescription: {{description}}\nStart Used: {{start_date}}\nEnd Used: {{end_date}}\nEnd Buffer: {{end_buffer}}',
    reservation_status:
      'Description: {{description}}\nStart Used: {{start_date}}\nEnd Used: {{end_date}}',
    search_reservation: 'Search by reservation id',
    no_vehicles_by_date: 'No vehicles available on requested times',
  },
  organization: {
    title: 'Organization',
    logo: 'Organization Logo',
    update_logo: 'Update logo',
    delete_logo: 'Delete logo',
    update_info: 'Update organization',
    basic_info: 'Basic information',
    name: 'Name',
    contact_info: 'Contact Information',
    time_zone: 'Time Zone',
    locale: 'Locale',
    zip_code: 'Postal Code',
    email: 'Email',
    description: 'Description',
    details: 'Organization Details',
    phone: 'Phone',
    file: 'File',
    address: 'Address',
    state: 'State',
    brokers: 'Organization Brokers',
    broker_deleted: 'Organization broker deleted',
    broker_disconnected: 'Organization broker disconnected',
    broker_updated: 'Organization broker updated',
    broker_connect_action: 'Connect',
    broker_connect_title: 'Connect with your Broker',
    broker_connect_hint:
      'To connect with your broker, you will need to enter the required integration details. If you are missing any of this information, please contact your provider to obtain the necessary details.',
    delete_broker: 'Delete Broker',
    delete_broker_msg: 'Are you sure you want to delete this broker? You can’t undo this.',
    disconnect_broker: 'Disconnect Broker',
    disconnect_broker_msg:
      'Some features may not work properly after disconnecting and you will need to re-enter your credentials again. If you are sure, just click Confirm.',
    link_account: 'Link Account',
    create_account: 'Create Account',
    verify_account: 'Verify Account',
    onboard: 'Onboard Stripe Account',
    payment_brokers_title: 'Receive Payments',
    payment_brokers_description_first_state:
      'It’s mandatory to link a bank account via Stripe (our payments gateway) to receive money from partners.',
    payment_brokers_description_second_state:
      'Your link to Stripe is incomplete. Remember, you must link a bank account via Stripe payments gateway to receive money from partners.',
    payment_brokers_description_third_state:
      'You have completed the steps to connect Stripe. It may take up to 5 days for your account to become active. In the meantime, please feel free to use the rest of your toolset, and come back here to confirm activation.',
    payment_brokers_description_fourth_state:
      'Stripe was configured successfully, your account is ready to receive payments!',
    payment_method_description:
      'You must link a credit card or bank account via Stripe payments gateway to send payments to partners.',
    account_created:
      'Payment account has been created successfully. You will be redirected to complete the onboarding proccess in a few seconds',
    update_organization_logo: 'Update organization logo',
    update_organization_info: 'Update Organization',
    image_size: 'The image format must be a PNG and the max width & height must be 155x55 pixels.',
    image_type: 'It must be white and have transparent background.',
    image_specs_title: 'Please prepare your logo following these next technical specs:',
    image_info_title:
      'This logo will be used in the blue header of the platform, and also in the header of the invoices your organization will produce.',
    onboarding_is_ready: 'Your account is ready for payments',
    onboarding_refresh: 'The link has expired. Please try again',
    onboarding_completed: 'You have completed the onboarding process',
    image_error: 'Image exceeds allowable size. Please resize and try again.',
    broker_connect: {
      success_title: 'Connection successfully established!',
      success_description: 'Please close this page to see the broker connection.',
      failure_title: 'There was a connection error!',
      failure_description: 'Please close this page and try the broker connection again.',
    },
  },
  instance: {
    reservation: 'Reservation',
    vehicle: 'Vehicle',
    driver: 'Driver',
    invoice: 'Invoice',
    subscription: 'Subscription',
    subscription_period: 'Subscription Period',
    fleet: 'Fleet',
  },
  customer_groups: {
    fleet: 'Fleet',
    timezone: 'Timezone',
    fleet_owner: 'Fleet Owner',
    vehicle_group: 'Under what group will this new group be created?',
    drive_rules: 'Driver rules',
    offline_rules: 'Offline rules',
    customer_label: 'Customer Facing Label',
    internal_name: 'Internal Identifier Name',
    general_info: 'Service Group General Info',
    general_info_description:
      'All vehicles in a Service Group are assigned shared location and pricing rules. Group your vehicles to segment them by class (e.g. Los Angeles – Mid-size), limit which users have access, and more.',
  },
  payment_method: {
    title: 'Payment Methods',
    empty: 'No payment methods',
    added: 'Payment method added successfully',
    updated: 'Payment method updated successfully',
    deleted: 'Payment method deleted successfully',
  },
  ruleset: {
    use_distance_allowance: 'Do you want to use Distance Allowance?',
    use_distance_allowance_description:
      'Set a maximum distance traveled allowed before additional charge applies',
    title: 'Ruleset',
    search: 'Search Ruleset Name',
    create: 'Create new Ruleset',
    ruleset_name: 'Ruleset Name',
    current_location_title: 'Current Location',
    select_pricing_ruleset: 'Select Pricing Ruleset',
    current_location_subtitle:
      'By changing the current ruleset, all vehicles in this group will inherit the new rules effective immediately. TIP: In order to change pricing for every vehicle group where this ruleset applies, edit the ruleset from the Pricing Rulesets page.',
    current_location_subtitle_fleet:
      'By changing the current ruleset, all vehicles in this fleet will inherit the new rules effective immediately. TIP: In order to change pricing for every fleet where this ruleset applies, edit the ruleset from the Pricing Rulesets page.',
    rulesel_apply_title: 'What pricing rules do you want to apply to this group?',
    rulesel_apply_subtitle:
      'These pricing rules will apply to all vehicles in this Service Group. After selecting your first ruleset, you can schedule other rulesets to become effective in the future.',
    rulesel_apply_subtitle_fleet:
      'These pricing rules will apply to all vehicles in this Fleet. After selecting your first ruleset, you can schedule other rulesets to become effective in the future.',
    delete_ruleset_title: 'Delete ruleset',
    archive_ruleset_title: 'Archive ruleset',
    active_vehicle_groups: 'Active on these service groups',
    active_fleets: 'Active on these fleets',
    updated_ruleset_msg: 'Pricing ruleset has been updated successfully!',
    delete_ruleset_description:
      'Do you want to delete this ruleset? You will not be able to go back!',
    archive_ruleset_description: 'Do you want to archive this ruleset?',
    ruleset_create: 'Create Ruleset',
    edit_ruleset: 'Edit Ruleset',
    clone_ruleset: 'Clone Ruleset',
    delete_ruleset: 'Delete Ruleset',
    mandatory: 'Mandatory',
    optional: 'Optional',
    create_sku: 'Create SKU',
    sku_description:
      'Manage the rule properties below. Each type of rule may have specific parameters to trigger the rule. Note: the item title and description will be visible on a customer invoice.',
    kind_rule: 'What kind of rule do you want to add?',
    requirement_type: 'Requirement Type',
    all_time_description:
      'Turn off the toggle to apply this price rule to a specific date range; otherwise, it will apply all the time.',
    select_sku: 'Select your SKU',
    rates_configuration: 'Rates & Configuration',
    schedule_time: 'Schedule Time',
    rate: 'Rate',
    enter_rate: 'Enter a Rate',
    calculation_options: 'Calculation Options',
    calculation_options_description:
      'Use the dropdown to set the duration rounding (Round up, Round down, or Exact Duration) for per-SKU price calculations.',
    calculation_options_note:
      "Duration rounding is a rule that adjusts a reservation's total time by rounding it up, down, or exact duration before calculating the final price.",
    round_type_placeholder: 'Select a Rounding Option',
    max_time: 'Max time to bill',
    enter_max_time: 'Enter a max time',
    grace_period: 'Grace period',
    enter_grace_period: 'Enter a grace period',
    operator: 'Operator',
    level_pct: 'Level PCT',
    enter_level_pct: 'Enter a level PCT',
    financing_factor: 'Financing factor',
    enter_financing_factor: 'Enter financing factor',
    out_of_state: 'Out of State',
    enter_out_of_state: 'Enter an Out of State',
    tiers: 'Tiers',
    start_hour: 'Start Hour',
    end_hour: 'End Hour',
    select_hour: 'Select a hour',
    select_day: 'Select a day',
    start_day: 'Start day',
    end_day: 'End day',
    ruleset_logs: 'Ruleset Log',
    added: 'Rule added successfully.',
    created: 'Ruleset created successfully.',
    updated: 'Ruleset updated successfully.',
    deleted: 'Ruleset deleted successfully.',
    description_1:
      'Manage pricing rules to apply across all reservations or during a specified time. You can set up recurring revenue or fees in the top chart, and promotions or credits on the bottom. All rules listed here will be applied automatically to any associated vehicles. Ensure that you have not created any duplicate or conflicting rules to prevent any unwanted double charges.',
    description_2:
      'Note on tiered pricing: you can have multiple time-based rules at the same time to enable different rates for different units (e.g. hours vs. days). The lowest rate will be calculated at reservation quote and end and applied to the reservation. You must fill the entire week with each unit to enable this feature. Promotions will only apply if the unit associated matches the unit applied to a reservation (e.g. hourly discount will only apply to hour-based reservation).',
    description_1_fleet:
      'Manage pricing rules to apply across all reservations done by your partner.  All rules listed here will be applied automatically to any vehicle associated with this, and a Fleet. Ensure that you have not created any duplicate or conflicting rules to prevent any unwanted double charges.',
    description_2_fleet:
      'Note on tiered pricing: you can have multiple time-based rules at the same time to enable different rates for different units (e.g. hours vs. days). Invoices from the reservations based on vehicle usage will automatically use the values listed here.',
    sku_type: 'SKU Type',
    sku_name: 'SKU Name',
    times: 'Times',
    associated_vg: 'Associated Service Groups',
    associated_fleet: 'Associated Fleets',
    less_than: 'Less than',
    greater_than: 'Greater than',
    less_or_equal: 'Less or equal',
    greater_or_equal: 'Greater or equal',
    add_rule: 'Add Rule',
    max_time_description:
      'This quantity is the most an user can be charged for being late at your entered rate. Ex. If your price_unit is "HOUR" and you want to charge users for at most 3 hours late, enter "max_time_to_bill" = 3.',
    grace_period_description:
      'A user will not be charged if they returned vehicle late less than this amount. Ex. If your price unit = "HOUR" and you do not want to charge users unless they are more than 15 minutes late, enter "grace_period" = (15/60) = 0.25. Enter 0 if there should be no grace period.',
    level_pct_description:
      'The percentage of energy level of the vehicle to compare against when the reservation ends.',
    cancel_title: 'Are you sure you want to leave?',
    cancel_description:
      'You have unsaved change. If you leave this page, all unsafe changes will be lost. Are you sure you want leave this page?',
    periods: 'Periods',
    add_new_tier: 'Add New Tier',
    multitier: 'Multitier',
    rate_error: 'Both period and rate should be numeric values',
    until_end_week: 'Until end of week',
    pricing: 'Pricing Ruleset',
    distance_allowance: 'Distance Allowance',
    distance_allowance_description:
      'You can set a included amount of miles/kms per hour to be included as part of the Reservation, independently of the duration. Any exceeding distance to that number will be charged to the Driver based on the Distance Rate. If values are set to zero, all the miles will be charged.',
    included_units: 'Included {{units}}',
    timeframe: 'Timeframe',
    per_extra_unit: 'per extra {{unit}}',
    per_unit: 'Per {{unit}}',
    rate_per_extra_unit: 'Rate per extra {{unit}}',
    reservation_acceptance_excess: 'Reservation Acceptable Excess',
    timeframes: {
      HOURLY: 'Hourly',
      DAILY: 'Daily',
      WEEKLY: 'Weekly',
      MONTHLY: 'Monthly',
    },
    equal_to: "That's equal to",
    units_per_hour: '{{units}} per hour',
    units_per_day: '{{units}} per day',
    units_per_month: '{{units}} per month',
    units_per_week: '{{units}} per week',
  },
  tax_ruleset: {
    associated_tax_rulesets: 'Associated Tax Rulesets',
    rulesets_history: 'Rulesets History',
    rulesets: 'Rulesets',
    sku: 'SKU',
    tax: 'Tax',
    add_tax: 'Add Tax',
    logs: 'Rulesets Log',
    title: 'Tax Rulesets',
    clone: 'Clone Tax Ruleset',
    create: 'Create Tax Ruleset',
    update: 'Update Tax Ruleset',
    ruleset_name: 'Ruleset Name',
    search: 'Search Tax Ruleset',
    avtive_sku: 'Active on this SKU',
    sku_associated: 'SKUs Associated',
    tax_ruleset_name: 'Tax Ruleset Name',
    delete_ruleset_title: 'Delete Tax Ruleset',
    deleted: 'Tax Ruleset deleted successfully',
    created: 'Tax ruleset has been created successfully',
    updated: 'Tax ruleset has been updated successfully',
    delete_ruleset_description:
      'Do you want to delete this tax ruleset? You will not be able to go back!',
    tax_modal: {
      tax: 'Tax',
      create: 'Create Tax',
      update: 'Update Tax',
      location: 'Location',
    },
    clone_tax_ruleset: 'Clone Tax Ruleset',
    edit_tax_ruleset: 'Edit Tax Ruleset',
    delete_tax_ruleset: 'Delete Tax Ruleset',
  },
  subscriptions: {
    title: 'Subscriptions',
    details: 'Subscription Details',
    statuses: {
      PENDING: 'Pending',
      CANCELLED: 'Cancelled',
      INPROGRESS: 'In Progress',
      COMPLETED: 'Completed',
      RESERVED: 'Reserved',
      REJECTED: 'Rejected',
      STARTEXCHANGE: 'Delivery Process',
      ENDEXCHANGE: 'Return Process',
    },
    status_details: {
      pending: 'Pending',
      inprogress: 'In Progress',
      cancelled: 'Cancelled',
      completed: 'Completed',
      rejected: 'Rejected',
      startexchange: 'Delivery Process',
      markasdelivered: 'Mark as Delivered',
      endexchange: 'Return Process',
      needsapproval: 'Needs Approval',
      deliveryinprogress: `Delivery in Progress`,
      available: 'Available',
      unpaid: 'Unpaid',
      scheduledelivery: 'Schedule Delivery',
      markasreturned: 'Mark as Returned',
    },
    logs: 'Subscription Logs',
    periods_invoices: 'Periods - Invoices',
    current_vehicle: 'Current Vehicle',
    period_length: 'Period Length',
    periodic_payment: 'Periodic Payment',
    term_balance: 'Term Balance',
    vin: 'VIN',
    start_address: 'Start Address',
    end_address: 'End Address',
    schedule_delivery: 'Schedule Delivery',
    mark_delivered: 'Mark Delivered',
    schedule_return: 'Schedule Return',
    mark_returned: 'Mark Returned',
    rate: 'Rate',
    activation_fee: 'Activation Fee',
    delivery_fee: 'Delivery Fee',
    information: 'Subscription Information',
    pricing: 'Pricing',
    period_type: {
      DAILY: 'Daily',
      WEEKLY: 'Weekly',
      MONTHLY: 'Month',
      QUARTERLY: 'Quarterly',
      BIYEARLY: 'Biyearly',
      YEARLY: 'Yearly',
      FIFTEEN: 'FIFTEEN',
      SEVEN: 'SEVEN',
      FIVE: 'FIVE',
    },
    cancel_subscription: 'Cancel Subscription',
    cancel_msg: 'Are you sure you want to cancel this subscription?',
    cancelled: 'Subscription canceled successfully',
    reservation_periods: 'Reservation - Periods',
    choose_address: 'Choose the way you want to receive your vehicle',
    agree_address: 'I agree to have the vehicle delivered to the specified address',
    pick_up: 'Pick Up',
    delivery: 'Delivery',
    address_description: 'This address will apply for the current action',
    address_type: 'Address Type',
    VEHICLELOCATION: 'Pick Up',
    USERHOME: 'Delivery',
    successfully_canceled: 'Successfully Canceled',
    successfully_canceled_msg:
      'The subscription was successfully canceled. Do you want to make a refund?',
    refund: 'Refund',
    cancel_return_process: 'Cancel return process',
    cancel_return_process_msg:
      'Are you sure you want to cancel the return process for this subscription?',
    end_subscription: 'End subscription',
    end_subscription_msg: 'Are you sure you want to end this subscription?',
    periods: 'Periods',
    quals: 'Subscription Qualifications',
    customer_quals: 'Customer Qualifications',
    item: 'Item',
    quantity: 'Quantity',
    date_added: 'Date Added',
    optional_items: 'Optional Items',
    add_optional_item: 'Add Optional Item',
    extra_items_total: 'Extra items total',
    select_optional_items: 'Sectect options you want to add to your subscription',
    items: 'Items',
    edit_user_address: 'Edit user address',
    subscription_id: 'Subscription ID',
    start_time: 'Start Time',
    end_time: 'End Time',
    vehicle: 'Vehicle',
    view_all: 'View all',
    no_subscriptions: 'No records to display',
    invoice_first_period: 'Invoice First Period',
    documents: 'Documents',
    contract: 'Contract',
  },
  reservation_rulesets: {
    delete_buffer: 'Delete buffer',
    confirm_delete_buffer: 'Do you want to delete this buffer? You will not be able to go back!',
    same_range_buffer_error: 'Buffer conflic: time selected already exist.',
    unsaved_changes: 'Please don’t forget to SAVE your changes!',
    time_frame: 'Reservation Length',
    buffer: 'Time range(s) for setting Technician reservations',
    add_buffer: 'Add Buffer',
    add_maintenance_buffer: 'Add Buffer',
    edit_maintenance_buffer: 'Update Buffer',
    reservation_length: 'Reservation Length',
    reservation_lengths: 'Reservation Length(s)',
    time_range_for_techs_reservation_line1: 'Time range(s) for setting',
    time_range_for_techs_reservation_line2: 'Technician Reservations',
    time_range_tooltip:
      'This defines the brackets of time in which the respective buffer applies. (i.e. Vehicles with Reservations up to 7 days will have a 6 hrs buffer for cleaning, before Mission Control marks them available for the next Reservation).',
    maintenance_buffer: 'Maintenance Buffer',
    time_range_fmt: 'From %{start_magnitude} %{start_units} up to %{magnitude} %{units}',
    time_range_fmt_default:
      'Buffer applies to all reservations unless different timeframes are specified.',
    time_range_fmt_default_tooltip:
      'A Reservation Ruleset has always a Buffer set by default when the Org was initially created. (i.e. Vehicles with Reservations from 1 hr to infinite days will have a 72 hrs buffer for maintenance, cleaning, etc, before Mission Control marks them available for the next Reservation).',
    maintenance_buffer_fmt: '%{magnitude} %{units}',
    maintenance_buffer_description:
      'Add buffers to control vehicle availability for the next reservation. Use this time for cleaning, maintenance, and other tasks. This is not automatically connected to technician reservations.',
    details_description_line1:
      'All the information below is required to manage the way Reservations are working in Mission Control.',
    details_description_line2:
      'As an Org you can only update the “Maintenance Buffer” portion of this whole set of info.',
    deleted_confirmation:
      'Your reservation time range has been updated. We adjusted the time range to fill in the gap created by deleting a time frame.',
    no_updates: 'No updates are present in the current ruleset, can not create a new ruleset',
    title: 'Reservation Rulesets',
    rules: 'Reservation Rules',
    view_order: 'View order',
    create_success: 'Ruleset successfully created',
    update_success: 'Ruleset successfully updated',
    delete_success: 'Ruleset successfully deleted',
    create_failure: 'Ruleset could not be created',
    update_failure: 'Ruleset could not be updated',
    delete_failure: 'Ruleset could not be deleted',
    rules_set: 'Ruleset',
    created_time: 'Created Time',
    create: 'Create Reservation Ruleset',
    edit: 'Edit Reservation Ruleset',
    delete: 'Delete Reservation Ruleset',
    clone: 'Clone Reservation Ruleset',
    search: 'Search Reservation Rulesets',
    description: 'TBD Description',
    ruleset_details: 'Ruleset Details',
    ruleset_name: 'Ruleset name',
    ruleset_description: 'Description',
    customers: 'Customers',
    non_customers: 'Technicians',
    payments: 'Payments',
    value: 'Value',
    unit: 'Unit',
    reservation_times: 'Reservation Times',
    cancel_reservation_rules: 'Cancel Reservation Rules',
    confirm_delete: 'Do you want to delete this ruleset? You will not be able to go back!',
    other: 'Other',
    app_reservation_configuration: 'App reservation configuration',
    duration_min: 'Duration Min',
    duration_min_description: 'Minimum duration of reservation length.',
    duration_max: 'Duration Max',
    duration_max_description: 'Maximum duration of reservation length.',
    timedelta_early_start: 'Timedelta Early Start',
    timedelta_early_start_description:
      'How far ahead of the reservation’s start time that a customer can begin their reservation.',
    timedelta_early_end: 'Timedelta Early End',
    timedelta_early_end_description:
      'How far ahead of the reservation’s end time that a customer can end their reservation.',
    timedelta_end_margin_buffer: 'Timedelta End Margin Buffer',
    timedelta_end_margin_buffer_description:
      'Buffer time added after a reservation to account for customers returning the vehicle late.',
    timedelta_end_service_buffer: 'Timedelta End Service Buffer',
    timedelta_end_service_buffer_description:
      'Length of time to block after a vehicle has been returned for any post-reservation maintenance/cleaning.',
    timedelta_reserve_ahead_min: 'Timedelta Reserve Ahead Min',
    timedelta_reserve_ahead_min_description:
      'Minimum amount of time required between when a customer makes a reservation and when their reservation can start.',
    timedelta_reserve_ahead_max: 'Timedelta Reserve Ahead Max',
    timedelta_reserve_ahead_max_description:
      'Maximum amount of time allowed between when a customer can make a reservation and when their reservation can start.',
    timedelta_vehicle_confirmed: 'Timedelta Vehicle Confirmed',
    timedelta_vehicle_confirmed_description:
      'Length of time before a reservation starts within which a vehicle is assigned to a customer.',
    duration_min_cancelled: 'Duration Min Cancelled',
    duration_min_cancelled_description:
      'Minimum amount of time to bill a customer for if they cancel.',
    timedelta_times_locked: 'Timedelta Times Locked',
    timedelta_times_locked_description:
      'Length of time before a reservation starts during which a cancellation fee will be charged if a customer cancels the reservation.',
    concurrent_max: 'Concurrent Max',
    concurrent_max_description: 'Maximum allowed concurrent reservations by a single customer.',
    timedelta_create_grace_period: 'Timedelta Create Grace Period',
    timedelta_create_grace_period_description:
      'Length of time after a reservation is created within which a customer can cancel/make changes to the reservation with no penalty.',
    timedelta_max_late: 'Timedelta Max Late',
    timedelta_max_late_description:
      'Added buffer time after reservation end for virtual (vehicle) key to exist within the app.',
    timedelta_upsell: 'Timedelta Upsell',
    timedelta_upsell_description:
      '+/- hours adjustment to the customer’s requested time frame for making reservation time suggestions during reservation creation.',
    start_time_resolution: 'Start Time Resolution',
    start_time_resolution_description:
      'Clock picker resolution for start time suggested in app on reservation creation screen.',
    end_time_resolution: 'End Time Resolution',
    end_time_resolution_description:
      'Clock picker resolution for end time suggested in app on reservation creation screen.',
    duration_default: 'Duration Default',
    duration_default_description:
      'Initial duration presented when the reservation creation screen loads on the app.',
    duration_adjust_end: 'Duration Adjust End',
    duration_adjust_end_description: 'Units of time in which the reservation can be made.',
    payment_framework: 'Payment Framework',
    select_payment: 'Select a payment framework',
    deferred: 'Deferred',
    traditional: 'Traditional',
    subscription: 'Subscription',
    statement: 'Statement',
    weekly: 'Weekly',
    atcheckin: 'At Checkin',
    at_creation: 'At Creation',
    at_start: 'At Start',
    at_end: 'At End',
    at_cancel: 'At Cancel',
    upon_modify: 'Upon Modify',
    no_disclaimer: 'There is not a disclaimer yet',
    disclaimer: 'Disclaimer',
    payment_details: 'Payment Details',
    charge_period: 'Charge Period',
    pre_auth_offset: 'Pre Authentication Offset',
    pre_auth_factor: 'Pre Authentication Factor',
    pre_auth_request: 'Pre Authentication Request',
    payment_grace_period: 'Payment Grace Period',
    pre_auth_offset_description:
      'Currency value to add to the estimated payment for card pre-authorization.',
    pre_auth_offset_example: '(Ex. for every pre-auth, authorize the estimated payment + $10.)',
    pre_auth_factor_description:
      'Multiplier of the estimated payment due. This value is used to authorize an amount different than the estimated payment.',
    pre_auth_factor_example:
      '(Ex: If the estimated payment is $10 and pre_auth_factor = 1.2, then the customer payment card will be authenticated for $12.)',
    direct: 'Direct',
    default: 'From %{start_magnitude} %{start_units} to Infinite',
    buffer_calculation: 'Buffer calculation',
    buffer_calculation_details:
      'The buffer time is the time the vehicle is unavailable after a reservation ends. The system takes the buffer that is closest to the reservation length. No overlapping time frames allowed. <br /><br /><strong>Example:</strong> If a reservation lasted exactly 8 hrs, and we have two Buffers sets, "A" (from 1hr up to 8 hrs) and buffer "B" (from 8hr up to 10 hrs), then the system will take buffer B for a reservation from 8 hrs or more.',
    lmk_link_note: 'Note: ',
    lmk_link_body:
      'If you need more information about Reservation Rulesets, feel free to check the  ',
    lmk_link_text: 'documentation',
  },
  reporting: {
    title: 'Reporting',
    download_success_title: 'Your report was successfully downloaded!',
    download_sucess_subtitle: 'Please check your local download folder',
  },
  'legacy-reports': {
    title: 'Legacy Reports',
  },
  reports: {
    parameter_types: {
      dimensions: 'Categorical',
      measures: 'Aggregate',
      segments: 'Predefined',
      filters: 'Custom Filter',
    },
    parameter_types_description: {
      dimensions:
        'A Categorical Value is a Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin condimentum rutrum dui, vitae porta dui tempor at. Maecenas sed massa pharetra quam aliquam dignissim.',
      measures:
        'A Aggregate Value is a Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin condimentum rutrum dui, vitae porta dui tempor at. Maecenas sed massa pharetra quam aliquam dignissim.',
      segments:
        'A Predefined is a subset of your data based on rules that define a meaningful grouping. Example: Reservation - Online Vehicle.',
    },
    last_modified: 'Last modified',
    title: 'Reports',
    search: 'Search report',
    create: 'Create report',
    edit: 'Edit report',
    measures: 'Measures',
    dimension: 'Dimension',
    dimensions: 'Dimensions',
    segments: 'Segments',
    export_report: 'Export Report',
    download_report: 'Download Report',
    save_report: 'Save Report',
    preview_report: 'Preview Report',
    type_of: 'Type of report:',
    loading_meta: 'Loading metadata...',
    request_success: 'Report requested successfully, it will arrive on your email shortly',
    create_success: 'Report has been created successfully',
    delete_success: 'Report has been deleted successfully',
    update_success: 'Report has been updated successfully',
    update_failure: 'Report could not be updated',
    new_report: 'Please select the data columns and filters for your report.',
    build_query: 'Build Your Query',
    add_parameters: 'Choose a measure or dimension to get started',
    query_error:
      'Your query is not ready to be saved or executed, please review that it has all the correct values',
    waiting_execution: 'Executing query, this could take a few minutes',
    delete: 'Delete Report',
    clone: 'Clone Report',
    delete_description: 'Do you want to delete this report? You will not be able to go back!',
    column_modal_title: 'Select Columns',
    predefined_modal_title: 'Predefined',
    predefined: 'Predefined',
    custom: 'Custom',
    custom_filter: 'Custom filter',
    column_order: 'Column Order',
    docs_info: 'For more information consult the Documentation of the reports.',
    add_edit_columns: 'Add / Edit Column',
    add_new_column: 'Add new column',
    add_new_custom_filter: 'Add new custom filter',
    add_new_predefined: 'Add new predefined',
    create_new_column: 'Create new column',
    create_new_predefined_filter: 'Enter a new predefined',
    create_new_custom_filter: 'Enter a new custom filter',
    no_filters_predefined: 'No predefined filters selected',
    no_filters_custom: 'No custom filters applied',
    no_time_dimensions: 'No time filters applied',
    column_modal_description: 'Select and arrange the columns for your report.',
    predefined_modal_description:
      'A predefined filter is a suggested condition that can be applied to dimensions and aggregates for commonly run reports. This helps to segment your data in a logical manner.',
    custom_modal_description: `A custom filter allows users to set conditions to filter the dimensions and measures specified according to user-defined values.`,
    time_dimensions_modal_description:
      'A time filter is a a convenient way to restrict your report with a categorical time value.',
    no_description: 'No description provided',
    view_documentation: 'View Documentation',
    report_documentation: 'Report Documentation',
    share_definition: 'Sharing this report with other member of your organization',
    error: {
      generic: 'There has been an error validating the report.',
      invalid_query_1: 'The report contains an incompatible set of categories (%{categories}).',
      invalid_query_2:
        'Please remove such incompatibilities to enable report saving and exporting.',
      network: 'Please try again, there has been a network error.',
      no_columns: 'Please select a at least one column.',
      meta_change:
        'The analytics engine does no longer have the values saved on this report, validate the existing report parameters (columns/filters).',
      bad_date_rage: 'Please review the date range, it should have a valid start and end date.',
    },
    no_options: 'No options were found for the provided keyword',
    view_docs: {
      1: 'To learn more, check out the ',
      2: 'Help Guide',
      3: ' on using the reporting engine.',
    },
    missing_value: 'Please insert a value for the filter',
    invalid_value: 'Invalid value for the filter',
    operators: {
      equals: 'equals',
      not_equals: 'does not equal',
      set: 'is set',
      not_set: 'is not set',
      before_date: 'before date',
      after_date: 'after date',
      contains: 'contains',
      not_contains: 'does not contain',
      in_date_range: 'in date range',
      not_in_date_range: 'not in date range',
      is_true: 'Is true',
      is_false: 'Is false',
    },
    data_ranges: {
      all_time: 'All time',
      today: 'Today',
      yesterday: 'Yesterday',
      this_week: 'This week',
      this_month: 'This month',
      this_quarter: 'This quarter',
      this_year: 'This year',
      last_seven_days: 'Last 7 days',
      last_thirty_days: 'Last 30 days',
      last_week: 'Last week',
      last_month: 'Last month',
      last_quarter: 'Last quarter',
      last_year: 'Last year',
    },
    granularities: {
      no_grouping: 'W/O Grouping',
      day: 'Day',
      week: 'Week',
      month: 'Month',
      year: 'Year',
    },
    documentation: {
      section_title: 'What is this reporting engine for?',
      dimensions: {
        title: 'What is a categorical value?',
        description:
          'A categorical value represents a commonly non-quantitative data field. For example, a categorical value can be a Vehicle Id, Reservation Status, or a Customer Created Time.',
      },
      measures: {
        title: 'What is an aggregate value?',
        description:
          'An aggregate value will show different types of calculations applied to selected fields (e.g., sum, average, percentages, etc.). For example, the column UserCount represents the number of users, or InvoiceSubtotalSum represents the sum of the subtotals of the invoices. Aggregate/Measure Columns are quantitative.',
      },
      segments: {
        title: 'What is a predefined filter?',
        description:
          'A predefined filter is a suggested condition that can be applied to dimensions and aggregates for commonly run reports. This helps to segment your data in a logical manner. ',
      },
      filters: {
        title: 'Custom Filter',
        description: `A custom filter allows users to set conditions to filter the dimensions and measures specified according to user-defined values. For example, you could filter locations by only specific locations like “Downtown,” “Long Beach,” etc., and the engine will retrieve only the specified data. When filtering a measure, it will filter the quantitative value (This is done after the aggregate). For example:
        Locations that have more than 50 Users (UserCount).
        Reservations that last for more than 3 days.
        `,
      },
    },
    preview: {
      1: 'Please click on the',
      2: 'Preview Report',
      3: 'button above to view the report',
    },
    last_executed: 'last execution date',
    clear_time: ' None',
    date_range: 'Date Range',
    start_date_range: 'Start Date',
    end_date_range: 'End Date',
    no_data: 'No records to display',
    reporting_templates: 'Reporting',
    reporting_templates_description:
      'This tool allows you to create reports using templates, these templates contain preloaded data, enabling you to generate reports immediately.',
    create_custom_report: 'Create Custom Report',
    template_card: {
      columns: 'This report contains the following columns:',
      generate_button: 'Generate',
      instruction:
        'The report can be modified once created by clicking the Add/Edit Column button on the report details screen.',
    },
    report_type_title: 'Select a type of report',
    report_type_description:
      'The column options will automatically adjust to match the report type selected.',
    select_report_type: 'Select report type',
    schedule_report: 'Schedule report',
    confirm_changes: 'Confirm changes',
    scheduler_modal: {
      manage_schedule: 'Manage Schedule',
      title: 'Schedule your reports',
      next_report_at: 'Next report at ',
      description:
        'Schedule your report by selecting a time and frequency. The system will then automatically generate and send your report as scheduled.',
      send_every: {
        label: 'Send every',
        time: {
          months: 'Month',
          weeks: 'Weeks',
          days: 'Days',
          hours: 'Hours',
        },
        scheduled: {
          monthly: 'Monthly',
          weekly: 'Weekly',
          daily: 'Daily',
          hourly: 'Hourly',
        },
      },
      on_time: {
        label: 'On time',
        week_days: {
          monday: 'Monday',
          tuesday: 'Tuesday',
          wednesday: 'Wednesday',
          thursday: 'Thursday',
          friday: 'Friday',
          saturday: 'Saturday',
        },
      },
      ends: 'Ends',
      never: 'Never',
      on: 'On',
      day: 'Day',
      delete_schedule: 'Delete schedule',
      edit_schedule: 'Edit schedule',
      add_schedule: 'Add schedule',
      scheduler_info:
        'To SCHEDULE REPORT you must have at least one group in the “Manage Destination” section located on the main screen.',
    },
    upgrade_reporting: {
      title: 'Upgrade Your Reporting Experience!',
      description:
        'Your legacy reports are still available, but to create new ones and unlock the latest features, head to <b>Reporting!</b>',
      stay_in_legacy: 'Stay in Legacy',
      reporting: 'Reporting',
    },
  },
  promo_codes: {
    title: 'Promo Codes',
    id: 'Promo Code ID',
    redemptions: '# Redemptions',
    details_title: 'Promo Code Details - ID #',
    info: 'Promo Code Information',
    logs: 'Promo Code Logs',
    create: 'Create Promo Code',
    promo_code: 'Promo Code',
    credit: 'Credit',
    basic_information: 'Basic Information',
    credit_type: 'Credit Type',
    start_time: 'Start time',
    expiration_time: 'Expiration time',
    create_success: 'Promo Code created successfully',
    edit: 'Edit Promo Code',
    delete: 'Delete Promo Code',
    delete_description: 'Do you want to delete this promo code? You will not be able to go back!',
    clone: 'Clone Promo Code',
    delete_success: 'Promo Code deleted successfully',
    delete_failure: 'Promo Code could not be deleted',
    accounting: 'Accounting',
    edit_accounting: 'Edit Accounting',
    edit_credit_type: 'Edit Credit Type',
    update: 'Update promo code information',
    update_success: 'Promo Code updated successfully',
    search: 'Search Promo Codes',
    search_placeholder: 'Search by Promo Code ID or Description',
    credit_amount: 'Credit Amount',
    is_active: 'Active Promo Codes',
    credit_type_info: 'Select a Credit type to associate with this Promo code.',
    basic_info_info:
      'A promo code name is required in order to create and save a promo code. All other fields are optional and can be edited after creation. A promo code must be Enabled for it to be available for redemption.',
  },
  credit_types: {
    title: 'Credit Types',
    id: 'Credit Type ID',
    details_title: 'Credit Type Details - ID# %{id}',
    create: 'Create Credit Type',
    credit: 'Credit',
    credit_amount: 'Credit Amount',
    create_success: 'Credit Type created successfully',
    update_success: 'Credit Type updated successfully',
    delete_success: 'Credit Type deleted successfully',
    edit: 'Edit Credit Type',
    clone: 'Clone Credit Type',
    search: 'Search Credit Type',
    credit_type: 'Credit Type',
    accounting_type: 'Accounting Type',
    no_accounting_types:
      '<b>Please contact support</b>, you cannot create Credit Types yet, because there’s no Accounting Type set up for this organization.',
    accounting_type_description: 'How do you want to show this Credit in your accounting?',
    default_price_description:
      'This value could be modified when assigning a credit to a customer.',
    info: 'Credit Type Information',
    logs: 'Credit Type Logs',
    create_credit_type: 'Create Credit Type',
    update_credit_type: 'Update Credit Type',
    delete: 'Delete Credit type',
    delete_description: 'Do you want to delete this credit type? You will not be able to go back!',
  },
  business_hours: {
    title: 'Business Hours',
    subtitle:
      'A business hour ruleset determines the hours of operation for when a reservation can be made. When a business hour ruleset is assigned to a service group, reservations must start and end within the times set.',
    error_msg_placeholder: 'Ex: "Reservation is outside the hours of operation for this location."',
    error_msg_title: 'Error message displayed to the user',
    error_msg_subtitle_1:
      'When a reservation is requested that does not meet the business hour ruleset, an error message is presented to the user.',
    error_msg_subtitle_2: 'Please set the error message below:',
    create_button: 'Create Business Hours Ruleset',
    search: 'Search Business Hour',
    business_hour_name: 'Business Hour Name',
    edit_business_hour: 'Edit Business Hour',
    include_archived: 'Include archived',
    active_vehicle_groups: 'Active on these service groups',
    delete_business_hour: 'Delete Business Hour',
    activate_business_hour: 'Activate Business Hour',
    delete_business_hour_title: 'Delete Business Hour',
    delete_business_hour_description: 'Do you want to archive this business hour?',
    business_hour_ruleset_name: 'Business Hour Ruleset Name',
    update: 'Update Business Hours Ruleset',
    create: 'Create Business Hour Ruleset',
    clone: 'Clone Business Hour Ruleset',
    archive_title: 'Archive Business Hours',
    activate_title: 'Activate Business Hours',
    archive_confirm: 'Are you sure you want to archive this ruleset?',
    activate_confirm: 'Are you sure you want to activate this ruleset?',
    day: 'Day',
    from: 'From',
    to: 'To',
    add_rule: 'Add Rule',
    select_time: 'Select Time',
    closed: 'Closed',
    open: 'Open 24 hours',
    apply: 'Apply to all',
    split_time: 'Add split time',
    select_time_description:
      'Add the days and the time that you want to apply this business hours rule set',
    created_successfully: 'Business Hours has been created successfully',
    updated_successfully: 'Business Hours has been updated successfully',
    ruleset_name: 'Ruleset Name',
    duplicate: 'Duplicate',
    archive: 'Archive',
    activate: 'Activate',
    effective_from: 'Effective from:',
    effective_to: 'onward',
    errors: {
      OVERLAPPING:
        'One range should not start exactly where another ends, if this is the case merge them into one',
      DEFAULT: "There's a conflict in the provided hour range, please provide a valid schedule.",
    },
  },
  charts: {
    title: 'Charts',
    quick_range: 'Quick Range',
    grouped: 'Grouped',
    date_range: 'Date Range',
    view_definition: 'View Definition',
  },
  partners: {
    statuses: {
      ACTIVE: 'Active',
      REQUESTED: 'Requested',
      CANCELLED: 'Cancelled',
      CANREQUESTED: 'Cancel Requested',
      REJECTED: 'Rejected',
      ONHOLD: 'On Hold',
    },
    statuses_update: {
      //TODO: FAAS Statuses will be updated with ticket: AGI-1554
      REQUESTED: {
        label: 'Send Invitation again',
        labelDescription: '',
        labelWarning: '',
        confirmTitle: '',
        confirmMessage: '',
      },
      ACTIVE: {
        label: 'Approve',
        labelDescription: '',
        labelWarning: '',
        confirmTitle: '',
        confirmMessage: '',
      },
      REJECT: {
        label: 'Reject',
        labelDescription: '',
        labelWarning: '',
        confirmTitle: '',
        confirmMessage: '',
      },
      CANCELLED: {
        label: 'Approve cancellation',
        labelDescription: '',
        labelWarning: '',
        confirmTitle: '',
        confirmMessage: '',
      },
      CAN_TO_ACTIVE: {
        label: 'Decline cancellation',
        labelDescription: '',
        labelWarning: '',
        confirmTitle: '',
        confirmMessage: '',
      },
      CANREQUESTED: {
        label: 'Request cancellation',
        labelDescription: '',
        labelWarning: '',
        confirmTitle: '',
        confirmMessage: '',
      },
      ONHOLD_FFB: {
        label: 'HOLD-ON:',
        labelDescription:
          'Your <b>Business</b> partner won’t be able to create or modify Reservations, and invite new users or Drivers; till this status is updated by you to <b>“Active”</b> again.',
        labelWarning: '',
        confirmTitle: 'Are you sure you want to Hold’on this Partnership?',
        confirmMessage: 'This action can be reversed anytime you want!',
      },
      CANCELLED_FFB: {
        label: 'CANCEL:',
        labelDescription:
          'By Cancelling the partnership your <b>Business</b> partner will get all vehicles unshared, will lose access to Mission Control, and all their Drivers will lose access to the Mobile App.',
        labelWarning: 'This action cannot be reversed, please use it carefully!',
        confirmTitle: 'Are you sure you want to Cancel this Partnership?',
        confirmMessage:
          'This action cannot be reversed, if you want to have this company as Business partner again in the future, you have to start the process from scratch, sending a new Invitation.',
      },
      ACTIVE_FFB: {
        label: 'ACTIVE:',
        labelDescription:
          'Your <b>Business</b> partner will regain full control of Mission Control, being able to create or modify Reservations, and invite new users or Drivers.',
        labelWarning: '',
        confirmTitle: 'Are you sure you want to Active this Partnership again?',
        confirmMessage: 'This action can be reversed anytime you want!',
      },
    },
    type: {
      OWNER: 'Fleet Owner',
      SERVICE: 'Service Owner',
      BUSINESS: 'Business Owner',
    },
    title: 'Partners',
    invite: 'Invite',
    invites: 'See Invites',
    invite_list_title: 'Pending Invites',
    invite_partner: 'Invite Partner',
    search: 'Search Partner',
    search_placeholder: 'Search by Partner ID or Name',
    invite_title: 'Invite a Partner to Launch Mobility',
    invite_ffb_title: 'Invite a Business Owner',
    org_name: 'Business Name',
    business_email: 'Business Email',
    contact_phone: 'Business Phone',
    admin_email: 'Business Admin Email',
    terms_url: 'Terms & Conditions URL',
    faqs_url: "FAQ's URL",
    support_web_url: 'Support Center Web URL',
    support_sms_phone: 'Support Center SMS Phone',
    support_email: 'Support Center Email',
    email_sender_name: 'Email Sender Name',
    email_sender: 'Email Sender Email',
    company_info: 'COMPANY INFO',
    customer_sup_info: 'CUSTOMER SUPPORT INFO',
    secondary_description:
      'Note: As the user inviting the business, you will now have full access to the profile and will be able to provide customer support.',
    invite_description:
      'Please complete the form below so that you can start working with your partner.',
    partner_name: 'Partner Name',
    partner_contact: 'Contact',
    partner_email: 'Email',
    partner_phone: 'Phone',
    partner_type: 'Partner Role',
    details_title: 'Partner - ID# %{id}',
    confirmation_title: 'Thank you! With this information we’ll create a profile for {{org}}.',
    confirmation_description:
      'Once your invitation is accepted, your Partner’s status will change from <b>“Requested”</b> to <b>“Active”</b>',
    confirmation_ffb_title:
      'Thank you! With this information we’ll create a profile for<br>{{org}}',
    confirmation_ffb_description:
      'This process might take a couple of minutes, once completed, you’ll see a new Business Partner in the list.',
    remove_title: 'Remove Partner',
    remove_description:
      'Please consider that if you choose REMOVE, your partner won’t be removed right away to avoid possible mistakes. Sharing options and Info shared from now on will be stopped although both of you will be able to see past transactions.',
    logs: 'Partner Logs',
    update_title: 'Update Partner Status',
    update_status: 'Update Status',
    update_status_success: 'Partner status updated successfully',
    no_update_available: 'This partner can not be updated',
    remove_invite_title: 'Remove Partnership Invitation',
    remove_invite_description: 'Are you sure you want to delete this invitation?',
  },
  notifications: {
    title: 'Notifications',
    search: 'Search subject',
    search_placeholder: 'Search by subject',
    search_by_partner: 'Filter by Partner',
    subject: 'Subject',
    partner: 'Partner',
    related_to: 'Related to',
  },
  account_statement: {
    statuses: {
      PAID: 'Paid',
      PARTIAL: 'Partially Paid',
      UNPAID: 'Not Paid',
      VOID: 'Void',
      OVERPAID: 'Overpaid',
      UNPAIDINPROGRESS: 'In progress',
    },
    title: 'Account Statement',
    search: 'Search by Partner ID or Name',
    associated_invoices: 'Associated Invoices (%{invoices})',
    associated_reservations: 'Associated Reservations (%{reservations})',
    associated_payments: 'Associated Payments (%{payments})',
    Vehicle_ids: '%{quantity} (See Vehicle ID’s)',
    Reservation_ids: '%{quantity} (See Reservation ID’s)',
    Vehicle_modal_title: 'Vehicles related to “%{description}”',
    Reservation_modal_title: 'Reservation related to “%{description}”',
    invoice_ref: '%{status} - Account Statement',
    logs: 'Statement logs',
  },
  statement_entries: {
    list_title: 'Statement Entries',
    page_title: 'Entry Details',
    details_title: 'Statement Entry ID #%{id}',
    preview_title: 'Entry ID #%{id}',
    details: 'Entry details',
    widget_title: 'Statement Entry',
    money_flow: 'Money Flow',
    money_out: 'Money Out',
    money_in: 'Money In',
    logs: 'Entry logs',
    preview: 'Entry preview',
    information: 'Entry information',
    items: 'Entry items',
    associated: 'Associated Entries (%{entries})',
    create_new_invoice: 'Create new Statement Entry',
    wizard_title: 'Statement Entry Creation',
    invoice_created_successfully: 'Statement Entry created successfully',
    wizard_details_label: 'Statement Entry Details',
    discard_title: 'Discard invoice',
    discard_msg: 'Are you sure about deleting this statement entry?',
    save_title: 'Save statement entry',
    save_msg:
      'This statement entry will be saved internally, if you want to send it to your Partner or Customer please use the option Submit.',
    submit_title: 'Submit statement entry',
    submit_msg:
      'When submitted, this statement entry will be seen by your Partner or Customer. Do you still want to submit it?',
  },
  guiding: {
    default_intro: 'HOW TO...',
    owner_description: 'Set up your organization',
    default_description: 'Start with simple steps',
    default_call_to_action:
      'These are the basic steps to start your Mission Control journey. Follow them in the suggested order, but skip any steps you have already completed and focus on the ones you need.',
    title_modal: 'lm knowledge base',
    intro: 'WELCOME, LET’S CREATE & SHARE',
    more_title: 'MORE LINKS OF INTEREST',
    see_all_tutorials: 'SEE ALL TUTORIALS',
    fleets: 'FLEETS',
    service_groups: 'SERVICE GROUPS',
    description_fleets:
      'Yes, you’ll have more things to do, but your main mission is to create Fleets and share them with your Service.',
    description_service_groups:
      'Yes, you’ll have more things to do, but your main mission is to create Service Groups and share them with the Drivers through the Mobile App.',
    description_flatOrg:
      'Yes, you’ll have more things to do, but your main mission is to create Service Groups and share them with the Drivers.',
    call_to_action: 'Please follow the numbers to complete it!',
    show_on_startup: 'Show on startup',
    setting_up_mc: 'Setting up Mission Control >',
    invoicing_n_payments: 'Invoicing and Payments >',
    managing_telematic_solutions: 'Managing Telematics Solutions >',
    create: 'CREATE',
    tutorial: 'TUTORIAL',
    steps: {
      locations: 'LOCATIONS',
      fleets: 'FLEETS',
      vehicle_types: 'VEHICLE TYPES',
      vehicles: 'VEHICLES',
      skus: 'SKUs',
      tax_rulesets: 'TAX RULESETS',
      pricing_rulesets: 'PRICING RULESETS',
      business_hours: 'BUSINESS HOURS',
      service_groups: 'SERVICE GROUPS',
      user_group: 'USER GROUP',
    },
  },
  unauthorized: {
    title: 'Unauthorized',
    reason: 'Sorry, you don’t have permission to access this resource!',
    description: 'If you require authorization, please contact',
    contact: 'team@launchmobility.com',
    button: 'Back to Dashboard',
  },
  nfc: {
    name_already_exists: 'This card name is already in use.',
    device_id_already_exists: 'This UID number is already in use.',
    confirm_action: 'Confirm Action',
    access_device_registered: 'NFC card successfully registered',
    access_device_assigned: 'NFC card assigned to user',
    access_device_unassigned: 'NFC card unassigned from user',
    create_description: 'Enter the same alias name that appears on the NFC card.',
    card_name: 'Card Name',
    device_id: 'Type the NFC card serial number or UID',
    already_assinged: 'This user is already associated with another NFC card',
    nfc: 'NFC',
    logs: 'NFC Card Logs',
    assign_nfc_to_user: 'Assign NFC card',
    assign_ngc_to_user_description:
      'By assigning an NFC card to the user, the user will be able to access vehicles with integrated card readers.',
    unassign_nfc_card: 'Confirm Action',
    unassign_driver: 'Unassign',
    assign_nfc: 'Assign NFC Card',
    unassign_confirm:
      'This action might impact ongoing reservations. Remember you can create or assign a new card',
    assign_without_user:
      'To use this card with a reserved vehicle, please assign it to a customer first. You can easily edit and update the card details anytime.',
    no_nfc: 'No NFC has been assigned',
    assign_title: 'Assign NFC card',
    edit_assign_title: 'Edit assigned user',
    assign_note: 'Note: Users with assigned NFC cards will not be shown on this list.',
    external_type_description: 'NFC Card Type: %{external_type}',
    serial_description: 'NFC Serial-UID: %{serial}',
    assign_description: 'Select an user to assign this NFC card',
    reassign_description: 'You can reassign this NFC card to other user',
    assing_notes: 'You can reassign this NFC card to other user',
    add_access_device: 'Register NFC card',
    edit_access_device: 'Edit NFC Card',
    update_access_device: 'Edit NFC card information',
    widget_title: 'Card Information',
    invalid_serial_length: 'Serial should be exactly 10 characters long',
    edit_info: 'Edit NFC Card',
    delete_info: 'Delete NFC Card',
    title: 'NFC Cards',
    details_title: 'NFC Card #{{accessDeviceId}}',
    search_by: 'Search by Card Name/ Serial Number/ User ID',
    assign_search_by: 'Search by Serial Number/ Card Name',
    alias: 'Alias',
    serial_number: 'Serial Number',
    user_assigned: 'User Assigned',
    date_assigned: 'Date Assigned',
    filter_by_user_group: 'Filter by User Group',
    assign: 'Assign',
    assign_unassign: 'Assign/Unassign',
    unassign: 'Unassign NFC card',
    unassign_description:
      'Are you sure you want to unassign NFC card to user? You can’t undo this action.',
    tracking_number: 'Tracking Number',
    create: 'Register NFC Card',
    archive_nfc_card: 'Confirm Action',
    archive_description_nfc_card:
      'This action cannot be undone, if a user is assigned, create a new card or reassign another',
    access_device_archived: 'Access device archived successfully',
    status: {
      ACTIVE: 'Active',
      UNASSIGNED: 'Unassigned',
      ARCHIVED: 'Archived',
    },
    user_id: 'User ID',
    external_type: 'Choose a NFC card type',
    type: 'Type',
    serial: 'Serial',
    brokers: 'Brokers',
    edit_broker: 'Edit broker',
    widget_unassign_nfc: 'Unassign NFC Card',
    widget_assign_nfc: 'Assign NFC Card',
    select_broker: 'Select a Broker',
    select_broker_description:
      'The NFC registration details will vary based on the broker you choose. Pick a broker from the list to continue:',
    broker: 'Broker',
    no_broker_available: "We couldn't find any brokers linked to your organization",
  },
  destinations: {
    selection: {
      description:
        'Select the group you want to send your scheduled report to, you can select a group by clicking on the box in front of the name. If the group does not have e-mails assigned to it you will not be able to select it.',
      title: 'Send to Destination',
      search: 'Search Destination',
    },
    delete: {
      description:
        'Deleting the destination will also delete the associated scheduled reports and information. This action cannot be undone.',
      title: 'Confirm Action',
    },
    types: {
      description:
        'You must choose which type of destination you want to add to your list, all objects in the list can be chosen at the time of sharing a scheduled report.',
      coming_soon: 'More options comming soon...',
      email: 'Email',
    },
    validations: {
      invalid_email: 'Invalid email format',
      required: 'Field is required',
    },
    manage_destinations: 'Manage destinations',
    previous: 'Previous',
    delete_success: 'Group deleted successfully',
    update_success: 'Group updated successfully',
    create_success: 'Group created successfully',
    cancel: 'Cancel',
    confirm: 'Confirm',
    save_group: 'Save Group',
    group_name: 'Group Name',
    emails: 'Emails',
    create_password: 'Create your password',
    confirm_password: 'Confirm your password',
    password_tooltip:
      "Share this password with a user that doesn't have access to Mission Control. The user will be prompted to enter it in order to download each report that is sent.",
    pwd_match: 'Both password need to be the same',
    add_email: 'Add email address',
    on_create: 'Create',
    search: 'Search destination',
    send_title: 'Send to Destination',
    create_title: 'Destinations',
    manage_destinations_label: 'Destinations',
    create_description:
      'Create destinations to share scheduled reports by clicking the "Create" button. You can also edit or delete existing ones.',
    send_description:
      'Select the group you want to send your scheduled report to, you can select a group by clicking on the box in front of the name. If the group does not have e-mails assigned to it you will not be able to select it.',
    delete_destination_warning:
      'Confirming changes without a destination will stop scheduled reports.',
  },
  authentication: {
    title: 'Authentication',
    tab_title: 'Setup SSO Provider',
    sso_provider: 'SSO Provider',
    sso_provider_description:
      'Follow these steps to configure a provider for Single Sign On (SSO) provider. Keep in mind that the certificate may vary depending on the provider you are adding. Once set up, you’ll have the option to enable or disable it from the Providers List',
    sso_provider_note:
      '<b>Note:</b> This configuration is specifically for Microsoft Azure. To set up a different authentication provider, please reach out to our support team for assistance.',
    steps: {
      create_saml: 'Create SAML',
      connect_provider: 'Connect with provider',
      certificate: 'Import Certificate',
    },
    details: {
      title: 'SAML v2 Configuration',
      description:
        'You currently have a provider configured. Below, you’ll see a preview of the previously entered data. If you need to make changes, click “Edit Form.”',
      attached: 'Attached',
    },
    wizard: {
      name: 'Name',
      idp_endpoint: 'IdP Endpoint',
      domains: 'Managed Domains',
      tooltip: {
        name: 'This is user-defined, so pick something that describes this connection such as “Pied Piper Azure AD”.',
        idp_endpoint:
          'This value can be obtained from your application settings as demonstrated below. Copy the Login URL value into this field.',
        domains:
          'Specify one or more email domains managed by this provider. When set, the login button is hidden, and users must first enter their email. If the domain matches, they are redirected to the authorization endpoint for authentication. The identity provider must return an email matching one of these domains.',
        certificate: 'The PEM encoded X.509 certificate to import.',
        status:
          'The status value can be changed. To enable or disable the broker, click on “Edit Form” and use the toggle to update the status.',
      },
      placeholder: {
        name: 'Ex; Pied Piper via SAML',
        idp_endpoint: 'Ex; https://login.microsoftonline.com',
        domains: 'Insert domain or mutiple domains',
      },
      edit_saml: 'Edit SAML v2',
      edit_saml_description:
        'Once you save your SAML V2 configuration, click the “Providers List” tab to view the current configuration and integration details.',
      connect_with_provider: 'Connect with your provider',
      connect_with_provider_description:
        "Go to your provider’s site to retrieve the X.509 certificate. Once you have it, click 'Import Certificate' to proceed. Make sure the certificate is in the correct format before importing it. If you're unsure, check your provider’s documentation for guidance.",
      fields: 'Fields',
      callback_url: 'Callback URL (ACS)',
      issuer: 'Issuer',
      metadata_url: 'Metadata URL',
      import_certiticate_button: 'Import Certificate',
      import_certiticate_description:
        'You can add the provider with this form, where it will act as a Service Provider for the organization of your choice. Please note, you must have an X.509 certificate and fill in the required fields of the form.',
      certificate: 'Certificate',
      has_certificate:
        'You currently have a certificate uploaded. To replace it, click “Update Certificate.”',
      update_certificate: 'Update Certificate',
      import_certificate_success: 'Your provider has been successfully created!',
      turn_on_off: 'Turn On/Off Provider',
    },
    mfa_tab: {
      title: 'Setup MFA',
      content_title: 'Begin Setup',
      description: [
        'Multi-Factor Authentication (MFA) is a security feature that requires multiple forms of verification to access users account.',
        "Use the 'On login' dropdown options to disable or enable as required the MFA status.",
        'This settings affect all users in the organization, including App and Mission Control.',
      ],
      on_login: 'On Login',
      select_option: 'Select an option',
      disabled_option: 'Disabled: MFA is not required during App and Mission Control login.',
      required_option: 'Required: MFA is always required at App and Mission Control login.',
      confirm_action: 'Confirm Action',
      required_modal_message:
        'Changes will affect settings, when applying this action, users will have to set MFA at the next login.',
      disabled_modal_message:
        'Changing MFA settings can impact your organization security. Click confirm to proceed.',
    },
  },
};
